import React, { useState, useRef, useEffect, useLayoutEffect, forwardRef, Fragment as Fragment$2, useContext, useCallback, useMemo, cloneElement, Component, useReducer, createContext } from 'react';
import { sanitizeUrl } from '@braintree/sanitize-url';
import tokens from '@alicorpdigital/dali-design-tokens/build/web/theme-alicorp/tokens.json';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var Icon = function (_a) {
    var _b;
    var name = _a.name, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.weight, weight = _d === void 0 ? 'regular' : _d, className = _a.className, other = __rest(_a, ["name", "size", "weight", "className"]);
    var classNameList = classnames('dl-icon', (_b = {},
        _b["dli-" + name + (weight ? "-" + weight : '')] = !!name,
        _b["dl-icon-" + size] = size,
        _b), className);
    return React.createElement("i", __assign({ className: classNameList }, other));
};

var AlertBannerMessage = function (_a) {
    var children = _a.children, other = __rest(_a, ["children"]);
    return (React.createElement("div", __assign({ className: "dl-alert-banner-message" }, other), children));
};

var AlertBannerButtons = function (_a) {
    var children = _a.children, other = __rest(_a, ["children"]);
    return (React.createElement("div", __assign({ className: "dl-alert-banner-content-buttons" }, other), children));
};

var AlertBannerSeparator = function () { return React.createElement("div", null, "."); };

var AlertBanner = function (_a) {
    var _b;
    var _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, _d = _a.variant, variant = _d === void 0 ? 'negative' : _d, alertBannerHeight = _a.alertBannerHeight, className = _a.className, children = _a.children, _e = _a.hasNoAnimation, hasNoAnimation = _e === void 0 ? false : _e, other = __rest(_a, ["isOpen", "variant", "alertBannerHeight", "className", "children", "hasNoAnimation"]);
    var _f = useState(isOpen), showBanner = _f[0], setShowBanner = _f[1];
    var elRef = useRef(null);
    var classNameList = classnames('dl-alert-banner', (_b = {},
        _b["dl-alert-banner-" + variant] = variant,
        _b), className);
    useEffect(function () {
        if (isOpen) {
            setShowBanner(true);
        }
        if (!isOpen && hasNoAnimation) {
            setShowBanner(false);
        }
    }, [isOpen]);
    var onAnimationEnd = function () {
        if (!isOpen)
            setShowBanner(false);
    };
    useLayoutEffect(function () {
        if (!showBanner)
            return;
        var bannerHeight = elRef.current && elRef.current.offsetHeight;
        alertBannerHeight && alertBannerHeight(bannerHeight);
    }, [showBanner]);
    return showBanner ? (React.createElement("div", __assign({ className: classNameList, ref: elRef, style: {
            animation: !hasNoAnimation
                ? (isOpen ? 'fadeIn' : 'fadeOut') + " 250ms linear"
                : '',
            position: !hasNoAnimation ? 'absolute' : 'initial',
            top: !hasNoAnimation ? 0 : 'unset',
            left: !hasNoAnimation ? 0 : 'unset',
        }, onAnimationEnd: onAnimationEnd }, other),
        React.createElement(Icon, { name: variant === 'positive'
                ? 'thumbs-up'
                : variant === 'warning'
                    ? 'warning-circle'
                    : 'thumbs-down', weight: "bold", className: "dl-alert-banner-icon" }),
        React.createElement("div", { className: "dl-alert-banner-container" }, children))) : null;
};
AlertBanner.Message = AlertBannerMessage;
AlertBanner.Buttons = AlertBannerButtons;
AlertBanner.Separator = AlertBannerSeparator;

var Avatar = forwardRef(function (_a, ref) {
    var _b, _c;
    var imgSrc = _a.imgSrc, imgAlt = _a.imgAlt, _d = _a.size, size = _d === void 0 ? 'md' : _d, _e = _a.hasBadge, hasBadge = _e === void 0 ? false : _e, badgeStatus = _a.badgeStatus, _f = _a.isInverse, isInverse = _f === void 0 ? false : _f, className = _a.className, other = __rest(_a, ["imgSrc", "imgAlt", "size", "hasBadge", "badgeStatus", "isInverse", "className"]);
    var avatarList = classnames('dl-avatar', (_b = {},
        _b["dl-avatar-" + size] = size,
        _b["dl-avatar-inverse"] = isInverse,
        _b), className);
    var badgeList = classnames('dl-avatar-badge', (_c = {},
        _c["dl-avatar-badge-" + size] = size,
        _c), className);
    return (React.createElement("div", __assign({ className: avatarList, ref: ref }, other),
        imgSrc ? (React.createElement("img", { src: imgSrc, alt: imgAlt, className: "dl-avatar-image", "aria-hidden": "true", role: "img" })) : (React.createElement(Icon, { name: "user", size: size === 'lg' ? 'lg' : 'sm', weight: "bold", role: "img", "aria-hidden": "true" })),
        hasBadge && size !== 'lg' && (React.createElement("i", { className: badgeList, "aria-hidden": "false", "aria-label": badgeStatus, title: badgeStatus }))));
});
Avatar.displayName = 'Avatar';

var Backdrop = function (_a) {
    var isOpen = _a.isOpen, className = _a.className, onClick = _a.onClick, other = __rest(_a, ["isOpen", "className", "onClick"]);
    var classNameList = classnames("dl-backdrop", {
        show: isOpen,
    }, className);
    return React.createElement("div", __assign({ className: classNameList, onClick: onClick }, other));
};
Backdrop.defaultProps = {
    isOpen: false,
};

var Brand = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'alicorp' : _c, _d = _a.size, size = _d === void 0 ? 'md' : _d, _e = _a.inverse, inverse = _e === void 0 ? false : _e, _f = _a.isotype, isotype = _f === void 0 ? false : _f, className = _a.className, other = __rest(_a, ["variant", "size", "inverse", "isotype", "className"]);
    var classNameList = classnames('dl-brand', (_b = {},
        _b["dl-brand-" + variant] = variant,
        _b["dl-brand-" + variant + "-inverse"] = inverse,
        _b["dl-brand-" + size] = size,
        _b["dl-brand-isotype"] = isotype,
        _b), className);
    var render = null;
    switch (variant) {
        case 'alicorp': {
            render = (React.createElement("svg", { width: "165", height: "48", viewBox: "0 0 165 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { clipPath: "url(#clip0)" },
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.2327 14.1934C26.2327 14.1934 24.8393 13.2213 22.2937 12.735C18.9211 12.091 11.7259 12.1824 8.84292 6.85356C7.40123 4.16139 7.59387 1.99304 7.64213 0C7.64213 0 8.93656 0.669078 12.4853 1.06226C14.8572 1.32438 26.2884 1.23464 26.2327 14.1934Z", fill: "#91D65C" }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M81.4317 15.3109V21.9687C66.4402 15.7487 66.9682 37.6217 81.2357 30.8658C81.2357 32.8713 81.4317 35.445 81.4317 37.4514C51.447 47.4408 50.6303 6.70759 81.4276 15.3109", fill: inverse ? '#FFFFFF' : '#E62020' }),
                    React.createElement("path", { d: "M40.7768 4.5625H30.1322V38.4058H40.7768V4.5625Z", fill: inverse ? '#FFFFFF' : '#E62020' }),
                    React.createElement("path", { d: "M56.5556 4.611H45.2345V12.6671H56.5556V4.611Z", fill: inverse ? '#FFFFFF' : '#E62020' }),
                    React.createElement("path", { d: "M56.5556 15.0616H45.2345V38.5745H56.5556V15.0616Z", fill: inverse ? '#FFFFFF' : '#E62020' }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.747 26.3103C153.747 30.2296 152.59 31.3248 150.454 31.3248C148.319 31.3248 147.786 29.1915 147.786 29.1915V23.2562C147.786 23.2562 148.319 21.1246 150.454 21.1246C152.59 21.1246 153.747 22.2194 153.747 26.1383V26.3103ZM150.43 14.9426C148.885 15.7344 147.857 16.7808 147.246 17.5584V14.9986H136.997V47.5901H147.246V34.502C147.868 35.2838 148.912 36.3728 150.43 37.2706C152.992 38.7844 164.626 39.1209 165 28.2374V23.9737C164.624 13.0903 153.454 13.3908 150.43 14.9426Z", fill: inverse ? '#FFFFFF' : '#E62020' }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2713 30.9684C16.2713 30.9684 14.9839 33.6698 11.9986 33.6698C9.01335 33.6698 7.66736 26.5716 16.2713 28.0171V30.9684ZM15.6645 24.1574C15.6645 24.1574 5.99055 21.5759 1.92536 26.9285C-1.85231 31.9051 0.0389987 38.1054 6.63322 38.7883C12.7345 39.4202 15.9768 35.6657 15.9768 35.6657L16.0721 35.5831V38.3997H26.3689V22.9992C26.3689 22.9992 26.2158 16.6648 18.1445 15.0813C13.1779 14.1079 4.42305 15.2136 2.83822 16.0404L2.74211 22.2136C2.74211 22.2136 6.2892 20.3625 11.1963 20.4639C13.5504 20.5128 16.1929 20.999 15.9999 24.1099L15.6645 24.1574Z", fill: inverse ? '#FFFFFF' : '#E62020' }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M127.495 16.0888C126.294 17.1093 125.622 18.1791 125.285 19.1508L125.288 14.9982H114.564V38.7197H125.865V29.3218C125.959 25.0331 128.08 23.9358 129.177 23.4286C130.762 22.6961 134.051 22.7963 134.051 22.7963V14.5595C130.041 14.3879 128.564 15.1826 127.495 16.0888Z", fill: inverse ? '#FFFFFF' : '#E62020' }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M97.5974 31.8374C95.1847 31.8374 94.8287 30.3657 94.8287 26.0398C94.8287 21.7177 95.2862 20.8521 97.5974 20.8521C99.9112 20.8521 100.305 21.7177 100.305 26.0398C100.309 30.3652 100.016 31.8374 97.5991 31.8374H97.5974ZM97.892 14.3842C89.8622 14.3842 83.353 17.7738 83.353 26.5269C83.353 35.9696 91.5188 38.6709 97.892 38.6709C105.066 38.6709 112.432 35.8231 112.432 26.5269C112.432 17.5505 105.919 14.3842 97.892 14.3842Z", fill: inverse ? '#FFFFFF' : '#E62020' })),
                React.createElement("defs", null,
                    React.createElement("clipPath", null,
                        React.createElement("rect", { width: "165", height: "48", fill: "white" })))));
            if (isotype) {
                render = (React.createElement("svg", { width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40.5042 17.5318C40.5042 17.5318 38.7776 16.331 35.6235 15.7304C31.4446 14.9349 22.5291 15.0478 18.9569 8.46558C17.1705 5.14018 17.4092 2.46182 17.469 0C17.469 0 19.0729 0.826451 23.4701 1.31211C26.409 1.63589 40.5732 1.52504 40.5042 17.5318Z", fill: "#91D65C" }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.1614 38.252C28.1614 38.252 26.5662 41.5888 22.8672 41.5888C19.1683 41.5888 17.5005 32.8211 28.1614 34.6065V38.252ZM27.4096 29.8391C27.4096 29.8391 15.4228 26.6503 10.3857 33.2619C5.70483 39.409 8.04832 47.0677 16.2191 47.9112C23.7791 48.6917 27.7965 44.0542 27.7965 44.0542L27.9146 43.9521V47.4312H40.6731V28.4084C40.6731 28.4084 40.4835 20.5841 30.4824 18.6281C24.3285 17.4258 13.4805 18.7915 11.5168 19.8129L11.3977 27.4381C11.3977 27.4381 15.7928 25.1515 21.8731 25.2768C24.7901 25.3371 28.0643 25.9378 27.8251 29.7803L27.4096 29.8391Z", fill: inverse ? '#FFFFFF' : '#E62020' })));
            }
            break;
        }
        case 'genia': {
            render = (React.createElement("svg", { width: "102", height: "48", viewBox: "0 0 102 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.1736 12.8404C24.0324 8.64657 27.6106 5.48687 31.876 5.056C38.5744 4.36661 43.2977 9.10618 43.2691 15.1958V17.1778H28.0972C28.727 19.3609 30.5018 20.7684 33.3359 20.7684C35.5115 20.7684 37.3149 19.5907 38.1737 17.6949L42.4676 20.2514C40.7787 23.3249 37.6584 25.508 33.3072 25.508C26.3224 25.508 21.7995 19.5619 23.1736 12.8404ZM33.1927 9.70903C30.9026 9.70903 29.1851 10.9442 28.3549 12.8113H37.8588C37.1718 10.7719 35.4828 9.70903 33.1927 9.70903Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M57.0389 4.96924C54.806 4.96924 52.8595 5.94588 51.6285 7.58319V5.37139H46.2754V25.0765H51.6572V14.3048C51.6572 11.0014 53.3461 9.56522 55.3785 9.56522C57.7831 9.56522 58.9854 11.1163 58.9854 13.759V25.0765H64.4531V13.0408C64.4817 7.98537 61.6763 4.96924 57.0389 4.96924Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2465 6.98044L19.3668 4.79736L22.0004 8.56031L19.2236 10.5136C20.0252 12.0647 20.4259 13.8457 20.3401 15.7414C20.0824 21.1992 15.4164 25.594 9.97742 25.4791C4.22354 25.3643 -0.29939 20.5098 0.0154984 14.6499C0.30176 9.53695 4.3953 5.34314 9.4621 4.99843C12.0385 4.82609 14.3858 5.60165 16.2465 6.98044ZM5.31147 14.822C5.08247 17.8093 7.28668 20.3658 10.2066 20.3658C12.9547 20.3658 15.1589 18.0391 15.1589 15.2241C15.1589 12.4091 12.9261 10.0824 10.1493 10.1111C7.60157 10.1399 5.51186 12.2655 5.31147 14.822Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M73.5848 0.0571289V25.105H68.2031V0.0571289H73.5848Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M83.4035 20.3083H94.081L95.7984 25.0767H101.467L91.8478 0H85.6078L75.9893 25.0767H81.6283L83.4035 20.3083ZM88.7847 5.80233L92.6494 16.2869H84.9209L88.7847 5.80233Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.7086 31.9418C48.2219 31.2811 47.6781 31.2811 47.1055 31.2811L46.2754 31.2524V31.2813V38.9794H48.3938V34.843C48.3938 34.843 50.6552 37.7729 51.0846 38.3187C51.514 38.8644 51.9434 39.0081 52.5445 39.0081H53.5464V31.2811H51.4281V35.4175L48.7086 31.9418Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M59.816 32.4014C60.5317 31.6833 61.5336 31.2524 62.6787 31.2524C64.2244 31.2524 65.2263 31.9131 65.8848 32.8323L64.3103 34.0674C63.8809 33.5217 63.3943 33.177 62.65 33.177C61.5908 33.177 60.8466 34.0674 60.8466 35.1877V35.2164C60.8466 36.3654 61.5908 37.2559 62.65 37.2559C63.4515 37.2559 63.9095 36.8825 64.3676 36.3367L65.942 37.4569C65.2263 38.4336 64.253 39.1804 62.5928 39.1804C60.4171 39.1804 58.6996 37.5144 58.6996 35.2452V35.2164C58.6709 34.0962 59.1004 33.1195 59.816 32.4014Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M70.6648 31.1953C68.3175 31.1953 66.5713 32.9475 66.5713 35.1594C66.5713 37.3424 68.2889 39.0946 70.6362 39.0946C72.9835 39.0946 74.7298 37.3424 74.7298 35.1594V35.1306C74.7298 32.9475 72.9835 31.1953 70.6648 31.1953ZM70.6364 33.0907C71.7815 33.0907 72.583 34.0387 72.583 35.1589C72.583 36.2504 71.8101 37.1984 70.665 37.1696C69.4914 37.1696 68.7185 36.2218 68.7185 35.1302V35.1015C68.7185 34.0099 69.4914 33.0907 70.6364 33.0907Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M89.5865 33.1479H87.3252V31.2808H93.9661V33.1479H91.6767V39.0364H89.5865V33.1479Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M57.4104 31.2808H55.292V39.0077H57.4104V31.2808Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M86.1806 31.2808H84.0615V39.0077H86.1806V31.2808Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M97.6022 31.2808C98.375 31.2808 98.8048 31.5393 99.1196 32.3436C99.2056 32.6021 101.925 39.0364 101.925 39.0364H99.5486L98.9477 37.5715H96.1707L95.5988 39.0077H93.3945L96.6575 31.2808H97.6022ZM97.6311 33.8084L96.7724 35.9627H98.4609L97.6311 33.8084Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M76.0184 31.2808C76.8772 31.2808 77.2779 31.8265 77.3638 32.1425C77.6787 33.0042 78.7947 36.1353 78.7947 36.1353L80.5411 31.2808H82.8883L79.7972 39.0077H77.879L74.7588 31.2808H76.0184Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                React.createElement("path", { d: "M1.375 42.8047C2.18736 44.2131 3.31217 45.3711 4.65569 46.2475C6.28042 47.3116 8.21759 47.9375 10.311 47.9375V42.7734L1.375 42.8047Z", fill: inverse ? '#765FFF' : '#594EDC' }),
                React.createElement("path", { d: "M4.12528 42.8048H5.1876C5.1876 42.304 5.1876 41.7093 5.1876 41.7093C5.1876 40.9895 5.1876 40.6139 5.1876 39.4559C5.1876 38.5796 5.00013 37.8284 4.71893 37.2651C4.59395 37.046 4.46897 36.8269 4.31275 36.6391C3.25043 35.262 1.50073 34.8552 0.594631 34.7613C0.250939 34.73 0.0322266 34.73 0.0322266 34.73V35.7628V37.672C0.0322266 38.7674 0.18845 39.8315 0.500897 40.8017C0.71961 41.5216 1.03206 42.2101 1.40699 42.8361H2.96923L4.12528 42.8048Z", fill: "#765FFF" }),
                React.createElement("path", { d: "M13.9352 39.1741H20.4966C20.5591 38.6733 20.6216 38.1412 20.6216 37.6092C20.6216 34.3229 19.1219 31.4436 16.7785 29.5344C16.6223 29.4092 16.4973 29.3153 16.3411 29.1901C16.2786 29.1275 16.2161 29.0962 16.1536 29.0649L12.123 36.0443C13.2166 36.6703 13.9352 37.8596 13.9352 39.1741Z", fill: inverse ? '#DDD7FF' : '#1E2B95' }),
                React.createElement("path", { d: "M13.9349 39.2058C13.9349 41.2089 12.3102 42.8363 10.3105 42.8363V48.0004C14.6223 48.0004 18.2779 45.4027 19.8089 41.647C19.9339 41.3653 20.0277 41.0524 20.1214 40.7707C20.2776 40.2699 20.4026 39.7379 20.4651 39.2058H13.9349C13.9349 39.1745 13.9349 39.2058 13.9349 39.2058Z", fill: inverse ? '#BBAFFF' : '#3B3DB9' }),
                React.createElement("path", { d: "M10.3108 27.25H0C0 27.25 2.97973e-07 31.7882 3.09323 34.1668C4.18679 35.0118 5.65529 35.5752 7.65495 35.5752C8.65478 35.5752 9.52963 35.5752 10.3108 35.5752C10.9669 35.5752 11.5918 35.7629 12.1229 36.0759L16.1535 29.0966C14.4975 27.9385 12.4979 27.25 10.3108 27.25ZM5.09289 30.7553C4.59297 30.7553 4.18679 30.3485 4.18679 29.8477C4.18679 29.3469 4.59297 28.9401 5.09289 28.9401C5.5928 28.9401 5.99898 29.3469 5.99898 29.8477C5.99898 30.3485 5.5928 30.7553 5.09289 30.7553Z", fill: inverse ? '#FFFFFF' : '#001A72' })));
            if (isotype) {
                render = (React.createElement("svg", { width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M13.7754 42.2641C14.6724 43.8191 15.9143 45.0977 17.3978 46.0654C19.1917 47.2403 21.3306 47.9314 23.6421 47.9314V42.2295L13.7754 42.2641Z", fill: inverse ? '#765FFF' : '#594EDC' }),
                    React.createElement("path", { d: "M16.8123 42.2634H17.9853C17.9853 41.7105 17.9853 41.0539 17.9853 41.0539C17.9853 40.2591 17.9853 39.8444 17.9853 38.5658C17.9853 37.5982 17.7783 36.7688 17.4678 36.1468C17.3298 35.9049 17.1918 35.663 17.0193 35.4556C15.8463 33.9351 13.9144 33.4859 12.9139 33.3822C12.5345 33.3477 12.293 33.3477 12.293 33.3477V34.488V36.596C12.293 37.8055 12.4655 38.9805 12.8105 40.0518C13.0519 40.8466 13.3969 41.6068 13.8109 42.298H15.5359L16.8123 42.2634Z", fill: "#765FFF" }),
                    React.createElement("path", { d: "M33.6475 0L30.1631 2.45356C28.0932 0.898488 25.4368 0.0691145 22.5734 0.241901C16.9156 0.62203 12.3272 5.32182 12.0167 11.0238C11.6717 17.5896 16.7086 22.9806 23.1598 23.1188C29.2661 23.2225 34.4755 18.3153 34.7515 12.2333C34.855 10.1253 34.4065 8.12095 33.5095 6.39309L36.6144 4.21598L33.6475 0ZM23.4013 17.3823C20.1239 17.3823 17.6745 14.514 17.916 11.1965C18.123 8.3283 20.4689 5.9784 23.3323 5.94385C26.4372 5.90929 28.9212 8.50108 28.9212 11.6458C28.9212 14.7905 26.4717 17.3823 23.4013 17.3823Z", fill: inverse ? '#FFFFFF' : '#001A72' }),
                    React.createElement("path", { d: "M27.6445 38.2548H34.8893C34.9583 37.7018 35.0272 37.1144 35.0272 36.5269C35.0272 32.8984 33.3713 29.7191 30.7839 27.6111C30.6114 27.4729 30.4734 27.3692 30.3009 27.231C30.2319 27.1619 30.1629 27.1273 30.0939 27.0928L25.6436 34.799C26.851 35.4902 27.6445 36.8034 27.6445 38.2548Z", fill: inverse ? '#DDD7FF' : '#1E2B95' }),
                    React.createElement("path", { d: "M27.6444 38.2888C27.6444 40.5005 25.8505 42.2974 23.6426 42.2974V47.9994C28.4034 47.9994 32.4398 45.1311 34.1302 40.9843C34.2682 40.6732 34.3717 40.3277 34.4752 40.0167C34.6477 39.4637 34.7857 38.8763 34.8547 38.2888H27.6444C27.6444 38.2542 27.6444 38.2888 27.6444 38.2888Z", fill: inverse ? '#BBAFFF' : '#3B3DB9' }),
                    React.createElement("path", { d: "M23.6424 25.0884H12.2578C12.2578 25.0884 12.2578 30.0992 15.6732 32.7255C16.8807 33.6586 18.5021 34.2806 20.71 34.2806C21.814 34.2806 22.78 34.2806 23.6424 34.2806C24.3669 34.2806 25.0569 34.4879 25.6434 34.8335L30.0937 27.1273C28.2653 25.8486 26.0574 25.0884 23.6424 25.0884ZM17.8811 28.9588C17.3291 28.9588 16.8807 28.5095 16.8807 27.9566C16.8807 27.4037 17.3291 26.9545 17.8811 26.9545C18.4331 26.9545 18.8816 27.4037 18.8816 27.9566C18.8816 28.5095 18.4331 28.9588 17.8811 28.9588Z", fill: inverse ? '#FFFFFF' : '#001A72' })));
            }
            break;
        }
        case 'diadia': {
            render = (React.createElement("svg", { width: "96", height: "48", viewBox: "0 0 96 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M21.7585 7.19849H27.8628V24.4754H21.7585V7.19849Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                React.createElement("path", { d: "M69.6016 7.19849H75.7058V24.4754H69.6016V7.19849Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                React.createElement("path", { d: "M88.6066 13.3018V12.6816C88.6066 11.3022 87.7785 10.5431 86.1235 10.5431C84.2962 10.5431 83.3304 11.4401 82.9513 12.9917L77.365 12.0603C77.7785 8.99149 81.0206 6.61182 86.2624 6.61182C91.4697 6.61182 93.7679 8.99149 93.7679 13.4397V19.1294C93.7679 19.9574 93.9058 20.1642 94.7338 20.1642H95.1598V24.4745H93.3544C90.389 24.4745 89.6988 23.3708 89.6299 20.8878H88.9052C88.1805 23.4053 85.9867 25.0603 82.9868 25.0603C79.8491 25.0603 77.6072 23.0951 77.6072 19.9908C77.6062 15.8193 81.7443 13.8198 88.6066 13.3018ZM88.6066 16.4406C85.331 16.7507 83.5026 17.5443 83.5026 19.3716C83.5026 20.4409 84.1928 21.0266 85.4333 21.0266C87.1917 21.0266 88.6055 19.8196 88.6055 17.4744V16.4406H88.6066Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                React.createElement("path", { d: "M40.7081 13.3018V12.6816C40.7081 11.3022 39.8801 10.5431 38.2251 10.5431C36.3978 10.5431 35.4319 11.4401 35.0529 12.9917L29.4666 12.0603C29.88 8.99149 33.1222 6.61182 38.364 6.61182C43.5713 6.61182 45.8695 8.99149 45.8695 13.4397V19.1294C45.8695 19.9574 46.0073 20.1642 46.8353 20.1642H47.2614V24.4745H45.456C42.4905 24.4745 41.8003 23.3708 41.7314 20.8878H41.0068C40.2821 23.4053 38.0883 25.0603 35.0884 25.0603C31.9506 25.0603 29.7088 23.0951 29.7088 19.9908C29.7078 15.8193 33.8458 13.8198 40.7081 13.3018ZM40.7081 16.4406C37.4326 16.7507 35.6042 17.5443 35.6042 19.3716C35.6042 20.4409 36.2944 21.0266 37.5349 21.0266C39.2933 21.0266 40.7071 19.8196 40.7071 17.4744V16.4406H40.7081Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                React.createElement("path", { d: "M54.6321 6.54479C57.5276 6.54688 59.8353 8.13298 60.6612 10.5805L61.9821 10.5816C60.9838 9.02992 60.3991 7.34149 60.4002 4.61829L60.4022 0.344482L67.3638 0.348659L67.3491 24.4743L60.87 24.4701C60.9055 23.2297 61.319 22.1615 62.0092 21.0244L60.6884 21.0223C59.8259 23.4688 57.5151 25.0183 54.6207 25.0173C50.7948 25.0152 47.6038 21.2917 47.6069 15.7774C47.6101 10.2976 50.9097 6.5427 54.6321 6.54479ZM57.7083 11.2342C56.0198 11.2331 54.9506 12.6459 54.9485 15.7816C54.9464 18.8493 56.0491 20.3655 57.7031 20.3665C59.4604 20.3676 60.4952 18.7825 60.4973 15.7847C60.4983 12.7169 59.4656 11.2352 57.7083 11.2342Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                React.createElement("path", { d: "M7.02521 6.54479C9.9207 6.54688 12.2283 8.13298 13.0543 10.5805L14.3751 10.5816C13.3769 9.02992 12.7922 7.34149 12.7932 4.61829L12.7953 0.344482L19.7568 0.348659L19.7422 24.4743L13.2631 24.4701C13.2986 23.2297 13.7121 22.1615 14.4023 21.0244L13.0814 21.0223C12.2189 23.4688 9.90817 25.0183 7.01372 25.0173C3.18891 25.0152 -0.00313022 21.2917 2.30363e-06 15.7774C0.00313483 10.2976 3.30273 6.5427 7.02521 6.54479ZM10.1003 11.2342C8.41187 11.2331 7.34264 12.6459 7.34055 15.7816C7.33846 18.8493 8.44111 20.3655 10.0951 20.3665C11.8524 20.3676 12.8872 18.7825 12.8893 15.7847C12.8914 12.7169 11.8587 11.2352 10.1003 11.2342Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                React.createElement("path", { d: "M72.6557 5.78011e-07C74.4005 0.00104475 75.8132 1.4159 75.8122 3.16072L75.8112 5.11437L69.4939 5.11019L69.4949 3.15654C69.496 1.41277 70.9108 -0.0010436 72.6557 5.78011e-07Z", fill: "#E6261E" }),
                React.createElement("path", { d: "M24.796 5.78011e-07C26.5409 0.00104475 27.9536 1.4159 27.9526 3.16072L27.9515 5.11437L21.6343 5.11019L21.6353 3.15654C21.6364 1.41277 23.0512 -0.0010436 24.796 5.78011e-07Z", fill: "#E6261E" }),
                React.createElement("path", { d: "M21.7595 28.0999H75.8122C75.8122 40.2133 62.9428 48.0582 48.7274 47.9997C34.4536 48.0582 21.7595 40.8597 21.7595 28.0999Z", fill: "#E6261E" })));
            if (isotype) {
                render = (React.createElement("svg", { width: "148", height: "48", viewBox: "0 0 148 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M37.0837 16.3418H45.8041V41.1609H37.0837V16.3418Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                    React.createElement("path", { d: "M105.432 16.3418H114.152V41.1609H105.432V16.3418Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                    React.createElement("path", { d: "M132.581 25.1086V24.2176C132.581 22.2361 131.399 21.1456 129.034 21.1456C126.424 21.1456 125.044 22.4341 124.502 24.6631L116.522 23.3251C117.113 18.9166 121.744 15.498 129.233 15.498C136.672 15.498 139.955 18.9166 139.955 25.3066V33.4801C139.955 34.6696 140.152 34.9666 141.335 34.9666H141.943V41.1586H139.364C135.128 41.1586 134.142 39.5731 134.043 36.0061H133.008C131.973 39.6226 128.839 42.0001 124.553 42.0001C120.071 42.0001 116.868 39.1771 116.868 34.7176C116.867 28.7251 122.778 25.8526 132.581 25.1086ZM132.581 29.6176C127.902 30.0631 125.29 31.2031 125.29 33.8281C125.29 35.3641 126.276 36.2056 128.048 36.2056C130.56 36.2056 132.58 34.4716 132.58 31.1026V29.6176H132.581Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                    React.createElement("path", { d: "M64.1547 25.1086V24.2176C64.1547 22.2361 62.9718 21.1456 60.6075 21.1456C57.997 21.1456 56.6172 22.4341 56.0757 24.6631L48.0952 23.3251C48.6859 18.9166 53.3176 15.498 60.8059 15.498C68.2449 15.498 71.5281 18.9166 71.5281 25.3066V33.4801C71.5281 34.6696 71.725 34.9666 72.9079 34.9666H73.5165V41.1586H70.9374C66.701 41.1586 65.715 39.5731 65.6166 36.0061H64.5813C63.5461 39.6226 60.4121 42.0001 56.1265 42.0001C51.6439 42.0001 48.4413 39.1771 48.4413 34.7176C48.4398 28.7251 54.3513 25.8526 64.1547 25.1086ZM64.1547 29.6176C59.4753 30.0631 56.8633 31.2031 56.8633 33.8281C56.8633 35.3641 57.8493 36.2056 59.6215 36.2056C62.1335 36.2056 64.1532 34.4716 64.1532 31.1026V29.6176H64.1547Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                    React.createElement("path", { d: "M84.0463 15.4026C88.1828 15.4056 91.4794 17.6841 92.6593 21.2001L94.5463 21.2016C93.1203 18.9726 92.2849 16.5471 92.2864 12.6351L92.2894 6.49561L102.234 6.50161L102.214 41.1592L92.9577 41.1532C93.0084 39.3712 93.5991 37.8367 94.5851 36.2032L92.6981 36.2002C91.466 39.7147 88.1649 41.9407 84.0299 41.9392C78.5644 41.9362 74.0058 36.5872 74.0103 28.6657C74.0147 20.7936 78.7285 15.3996 84.0463 15.4026ZM88.4409 22.1392C86.0288 22.1377 84.5013 24.1672 84.4983 28.6717C84.4953 33.0787 86.0706 35.2567 88.4334 35.2582C90.9439 35.2597 92.4222 32.9827 92.4252 28.6762C92.4266 24.2692 90.9514 22.1406 88.4409 22.1392Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                    React.createElement("path", { d: "M16.0361 15.4026C20.1725 15.4056 23.4691 17.6841 24.6491 21.2001L26.536 21.2016C25.11 18.9726 24.2746 16.5471 24.2761 12.6351L24.2791 6.49561L34.2242 6.50161L34.2033 41.1592L24.9474 41.1532C24.9981 39.3712 25.5888 37.8367 26.5748 36.2032L24.6878 36.2002C23.4557 39.7147 20.1546 41.9407 16.0197 41.9392C10.5556 41.9362 5.99553 36.5872 6 28.6657C6.00448 20.7936 10.7182 15.3996 16.0361 15.4026ZM20.4291 22.1392C18.017 22.1377 16.4895 24.1672 16.4866 28.6717C16.4836 33.0787 18.0588 35.2567 20.4216 35.2582C22.9321 35.2597 24.4104 32.9827 24.4134 28.6762C24.4164 24.2692 22.9411 22.1406 20.4291 22.1392Z", fill: inverse ? '#FFFFFF' : '#3E28D1' }),
                    React.createElement("path", { d: "M109.795 6C112.287 6.0015 114.306 8.03401 114.304 10.5405L114.303 13.347L105.278 13.341L105.279 10.5345C105.281 8.02951 107.302 5.9985 109.795 6Z", fill: "#E6261E" }),
                    React.createElement("path", { d: "M41.4233 6C43.9159 6.0015 45.9342 8.03401 45.9327 10.5405L45.9312 13.347L36.9065 13.341L36.908 10.5345C36.9095 8.02951 38.9307 5.9985 41.4233 6Z", fill: "#E6261E" })));
            }
            break;
        }
        default:
            render = null;
    }
    return (React.createElement("div", __assign({ className: classNameList }, other), render));
};

var Button = React.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, variant = _a.variant, size = _a.size, className = _a.className, href = _a.href, isActive = _a.isActive, isBlock = _a.isBlock, isLoading = _a.isLoading, hasIcon = _a.hasIcon, iconName = _a.iconName, iconWeight = _a.iconWeight, isIconOnly = _a.isIconOnly, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, disabled = _a.disabled, other = __rest(_a, ["children", "variant", "size", "className", "href", "isActive", "isBlock", "isLoading", "hasIcon", "iconName", "iconWeight", "isIconOnly", "onClick", "onFocus", "onBlur", "disabled"]);
    var classNameList = classnames('dl-btn', (_b = {},
        _b["dl-btn-" + variant] = variant,
        _b["active"] = isActive,
        _b["dl-btn-" + size] = size,
        _b["dl-disabled"] = href && disabled,
        _b['dl-btn-block'] = isBlock,
        _b['dl-btn-loading'] = isLoading,
        _b["dl-btn-with-icon-" + hasIcon] = hasIcon,
        _b['dl-btn-icon-only'] = isIconOnly,
        _b), className);
    var icon = (React.createElement(Icon, { name: iconName || '', size: size === 'sm' || size === 'xs' ? 'sm' : 'md', weight: iconWeight }));
    return (React.createElement(Fragment$2, null, href ? (React.createElement("a", __assign({ className: classNameList, href: sanitizeUrl(href), role: "button", rel: other.target === '_blank' ? 'noopener noreferrer' : undefined }, other),
        hasIcon === 'left' && icon,
        children)) : (React.createElement("button", __assign({ className: classNameList, disabled: disabled, onClick: onClick, onFocus: onFocus, onBlur: onBlur, ref: ref }, other),
        React.createElement("span", { className: "dl-btn-content-text" }, isLoading ? (React.createElement("div", { className: "dl-btn-content-loading" },
            React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: size === 'lg' ? '32px' : '24px', height: size === 'lg' ? '32px' : '24px', viewBox: "0 0 50 50", xmlSpace: "preserve" },
                React.createElement("path", { fill: "currentColor", d: "M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z" },
                    React.createElement("animateTransform", { attributeType: "xml", attributeName: "transform", type: "rotate", from: "0 25 25", to: "360 25 25", dur: "0.6s", repeatCount: "indefinite" }))),
            React.createElement("span", null, hasIcon === 'left' && icon),
            React.createElement("span", null, children))) : (React.createElement(React.Fragment, null,
            hasIcon === 'left' && icon,
            !isIconOnly ? children : icon)))))));
});
Button.displayName = 'Button';
Button.defaultProps = {
    variant: 'primary',
    size: 'md',
    type: 'button',
    isActive: false,
    isBlock: false,
    isIconOnly: false,
};

var CardProductHeader = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-card-product-header', className);
    return (React.createElement("div", __assign({ className: classNameList }, other), children));
};

var CardProductBody = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-card-product-body', className);
    return (React.createElement("div", __assign({ className: classNameList }, other), children));
};

var CardProductBodyTop = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-card-product-body-top', className);
    return (React.createElement("div", __assign({ className: classNameList }, other), children));
};

var CardProductBodyBottom = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-card-product-body-bottom', className);
    return (React.createElement("div", __assign({ className: classNameList }, other), children));
};

var Img = function (_a) {
    var src = _a.src, alt = _a.alt, isResponsive = _a.isResponsive, className = _a.className, other = __rest(_a, ["src", "alt", "isResponsive", "className"]);
    var classNameList = classnames({ 'img-fluid': isResponsive }, className);
    return React.createElement("img", __assign({ className: classNameList, src: src, alt: alt }, other));
};
Img.defaultProps = {
    isResponsive: false,
};

var CardProductImage = function (_a) {
    var src = _a.src, name = _a.name, className = _a.className, _b = _a.hasActions, hasActions = _b === void 0 ? false : _b, _c = _a.mixBlendMode, mixBlendMode = _c === void 0 ? true : _c, other = __rest(_a, ["src", "name", "className", "hasActions", "mixBlendMode"]);
    var classNameList = classnames('dl-card-product-header-img', {
        'dl-card-product-header-img-has-actions': hasActions,
        'dl-card-product-header-img-blend-mode': mixBlendMode,
    }, className);
    return (React.createElement(Img, __assign({ className: classNameList, src: src, alt: name, isResponsive: true }, other)));
};

var Text = function (_a) {
    var _b;
    var children = _a.children, as = _a.as, size = _a.size, className = _a.className, other = __rest(_a, ["children", "as", "size", "className"]);
    var TextClasses = classnames('dl-text', (_b = {},
        _b["dl-text-" + size] = size,
        _b), className);
    var commonProps = {
        className: TextClasses,
    };
    var component = 'p';
    as && (component = as);
    return React.createElement(component, __assign(__assign({}, commonProps), other), children);
};
Text.defaultProps = {
    as: 'p',
    size: 'paragraph',
};

var CardProductTitle = function (_a) {
    var title = _a.title, className = _a.className, other = __rest(_a, ["title", "className"]);
    var classNameList = classnames('dl-card-product-title', className);
    return (React.createElement(Text, __assign({ className: classNameList }, other), title));
};

var CardProductDescription = function (_a) {
    var description = _a.description, className = _a.className, other = __rest(_a, ["description", "className"]);
    var classNameList = classnames('dl-card-product-description', className);
    return (React.createElement(Text, __assign({ className: classNameList }, other), description));
};

var CardProductAmounts = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-card-product-amounts', className);
    return (React.createElement("div", __assign({ className: classNameList }, other), children));
};

var CardProductDiscountPrice = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-card-product-discount-price', className);
    return (React.createElement(Text, __assign({ className: classNameList, size: "caption" }, other), children));
};

var CardProductFinalPrice = function (_a) {
    var className = _a.className, children = _a.children, hasDiscount = _a.hasDiscount, other = __rest(_a, ["className", "children", "hasDiscount"]);
    var classNameList = classnames('dl-card-product-final-price', {
        'dl-card-product-final-price-has-discount': hasDiscount,
    }, className);
    return (React.createElement(Text, __assign({ className: classNameList }, other), children));
};

var CardProductActions = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-card-product-actions', className);
    return (React.createElement("div", __assign({ className: classNameList }, other), children));
};

var CardProductMenu = function (_a) {
    var _b;
    var className = _a.className, _c = _a.position, position = _c === void 0 ? 'left' : _c, other = __rest(_a, ["className", "position"]);
    var classNameList = classnames('dl-card-product-menu', (_b = {},
        _b["dl-card-product-menu-" + position] = position,
        _b), className);
    return React.createElement("div", __assign({ className: classNameList }, other));
};

var CardProductTags = function (_a) {
    var className = _a.className, other = __rest(_a, ["className"]);
    var classNameList = classnames('dl-card-product-tags', className);
    return React.createElement("div", __assign({ className: classNameList }, other));
};

var CardProduct = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.hasStock, hasStock = _c === void 0 ? true : _c, _d = _a.horizontalResponsive, horizontalResponsive = _d === void 0 ? false : _d, _e = _a.isActive, isActive = _e === void 0 ? false : _e, _f = _a.kind, kind = _f === void 0 ? 'default' : _f, backgroundColor = _a.backgroundColor, border = _a.border, borderColor = _a.borderColor, borderStyle = _a.borderStyle, borderWidth = _a.borderWidth, width = _a.width, className = _a.className, children = _a.children, other = __rest(_a, ["hasStock", "horizontalResponsive", "isActive", "kind", "backgroundColor", "border", "borderColor", "borderStyle", "borderWidth", "width", "className", "children"]);
    var cardProductClassnames = classnames('dl-card-product', (_b = {},
        _b["dl-card-product-" + kind] = kind,
        _b['dl-card-product-no-stock'] = !hasStock,
        _b['dl-card-product-horizontal-responsive'] = horizontalResponsive,
        _b['dl-card-product-active'] = isActive,
        _b), className);
    var style = {
        backgroundColor: backgroundColor,
        border: border,
        borderColor: borderColor,
        borderStyle: borderStyle,
        borderWidth: borderWidth,
        width: width,
    };
    return (React.createElement("article", __assign({ className: cardProductClassnames, style: style, ref: ref }, other), children));
});
CardProduct.displayName = 'CardProduct';
CardProduct.Header = CardProductHeader;
CardProduct.Body = CardProductBody;
CardProduct.BodyTop = CardProductBodyTop;
CardProduct.BodyBottom = CardProductBodyBottom;
CardProduct.Image = CardProductImage;
CardProduct.Title = CardProductTitle;
CardProduct.Description = CardProductDescription;
CardProduct.Amounts = CardProductAmounts;
CardProduct.DiscountPrice = CardProductDiscountPrice;
CardProduct.FinalPrice = CardProductFinalPrice;
CardProduct.Actions = CardProductActions;
CardProduct.Menu = CardProductMenu;
CardProduct.Tags = CardProductTags;

var FormGroupContext = React.createContext({});

var Check = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var id = _a.id, name = _a.name, type = _a.type, size = _a.size, label = _a.label, value = _a.value, className = _a.className, inline = _a.inline, checked = _a.checked, disabled = _a.disabled, onClick = _a.onClick, onChange = _a.onChange, children = _a.children, other = __rest(_a, ["id", "name", "type", "size", "label", "value", "className", "inline", "checked", "disabled", "onClick", "onChange", "children"]);
    var controlId = useContext(FormGroupContext).controlId;
    var classNameList = classnames('dl-custom-control', (_b = {},
        _b["dl-custom-" + type] = type,
        _b['dl-custom-control-inline'] = inline,
        _b), className);
    var labelList = classnames('dl-custom-control-label', (_c = {},
        _c["dl-custom-control-label-" + size] = size,
        _c["dl-custom-control-label-" + type] = label || children,
        _c));
    return (React.createElement("div", { className: classNameList },
        React.createElement("input", __assign({ id: controlId || id, name: controlId || name, type: type === 'radio' ? 'radio' : 'checkbox', className: "dl-custom-control-input", disabled: disabled, value: value, checked: checked, 
            // onChange={(e) => onChange && onChange(e)}
            onChange: onChange, onClick: onClick, ref: ref }, other)),
        React.createElement("label", { className: labelList, htmlFor: controlId || id },
            React.createElement("span", null,
                " ",
                label || children))));
});
Check.displayName = 'Check';
Check.defaultProps = {
    type: 'checkbox',
    inline: false,
    disabled: false,
};

var Divider = function (_a) {
    var _b;
    var _c = _a.isInverse, isInverse = _c === void 0 ? false : _c, className = _a.className, other = __rest(_a, ["isInverse", "className"]);
    var classNameList = classnames('dl-divider', (_b = {},
        _b["dl-divider-inverse"] = isInverse,
        _b), className);
    return React.createElement("div", __assign({ className: classNameList }, other));
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e$2=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$2=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$1=b$1?
Symbol.for("react.suspense_list"):60120,r$2=b$1?Symbol.for("react.memo"):60115,t$1=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$1:case m$1:case e$2:case g$1:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$2:case t$1:case r$2:case h$1:return a;default:return u}}case d$1:return u}}}function A$1(a){return z$1(a)===m$1}var AsyncMode=l$1;var ConcurrentMode=m$1;var ContextConsumer$1=k$1;var ContextProvider$1=h$1;var Element$1=c$1;var ForwardRef$1=n$2;var Fragment$1=e$2;var Lazy$1=t$1;var Memo$1=r$2;var Portal$1=d$1;
var Profiler$1=g$1;var StrictMode$1=f$1;var Suspense$1=p$1;var isAsyncMode$1=function(a){return A$1(a)||z$1(a)===l$1};var isConcurrentMode$1=A$1;var isContextConsumer$1=function(a){return z$1(a)===k$1};var isContextProvider$1=function(a){return z$1(a)===h$1};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};var isForwardRef$1=function(a){return z$1(a)===n$2};var isFragment$1=function(a){return z$1(a)===e$2};var isLazy$1=function(a){return z$1(a)===t$1};
var isMemo$1=function(a){return z$1(a)===r$2};var isPortal$1=function(a){return z$1(a)===d$1};var isProfiler$1=function(a){return z$1(a)===g$1};var isStrictMode$1=function(a){return z$1(a)===f$1};var isSuspense$1=function(a){return z$1(a)===p$1};
var isValidElementType$1=function(a){return "string"===typeof a||"function"===typeof a||a===e$2||a===m$1||a===g$1||a===f$1||a===p$1||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$2||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$2||a.$$typeof===w$1||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};var typeOf$1=z$1;

var reactIs_production_min$1 = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer$1,
	ContextProvider: ContextProvider$1,
	Element: Element$1,
	ForwardRef: ForwardRef$1,
	Fragment: Fragment$1,
	Lazy: Lazy$1,
	Memo: Memo$1,
	Portal: Portal$1,
	Profiler: Profiler$1,
	StrictMode: StrictMode$1,
	Suspense: Suspense$1,
	isAsyncMode: isAsyncMode$1,
	isConcurrentMode: isConcurrentMode$1,
	isContextConsumer: isContextConsumer$1,
	isContextProvider: isContextProvider$1,
	isElement: isElement$1,
	isForwardRef: isForwardRef$1,
	isFragment: isFragment$1,
	isLazy: isLazy$1,
	isMemo: isMemo$1,
	isPortal: isPortal$1,
	isProfiler: isProfiler$1,
	isStrictMode: isStrictMode$1,
	isSuspense: isSuspense$1,
	isValidElementType: isValidElementType$1,
	typeOf: typeOf$1
};

var reactIs_development$1 = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs$1 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$1;
} else {
  module.exports = reactIs_development$1;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e$1=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n$1=60115,p=60116,q=60121,r$1=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e$1=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n$1=x("react.memo");p=x("react.lazy");q=x("react.block");r$1=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e$1:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n$1:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n$1,F=c,G=f,H=e$1,I=l;var ContextConsumer=h;var ContextProvider=z;var Element=A;var ForwardRef=B;var Fragment=C;var Lazy=D;var Memo=E;var Portal=F;var Profiler=G;var StrictMode=H;
var Suspense=I;var isAsyncMode=function(){return !1};var isConcurrentMode=function(){return !1};var isContextConsumer=function(a){return y(a)===h};var isContextProvider=function(a){return y(a)===g};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};var isForwardRef=function(a){return y(a)===k};var isFragment=function(a){return y(a)===d};var isLazy=function(a){return y(a)===p};var isMemo=function(a){return y(a)===n$1};
var isPortal=function(a){return y(a)===c};var isProfiler=function(a){return y(a)===f};var isStrictMode=function(a){return y(a)===e$1};var isSuspense=function(a){return y(a)===l};var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e$1||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n$1||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r$1)?!0:!1};
var typeOf=y;

var reactIs_production_min = {
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

function t(t){return "object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return (!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return !1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}function computeScrollIntoView(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p);}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else {F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)));}C.push({el:k,top:F,left:G});}return C}

var idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}

function noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */


function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }

  var actions = computeScrollIntoView(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */


function debounce(fn, time) {
  var timeoutId;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }

  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */


function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}

function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */


function generateId() {
  return String(idCounter++);
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */


function getA11yStatusMessage$1(_ref2) {
  var isOpen = _ref2.isOpen,
      resultCount = _ref2.resultCount,
      previousResultCount = _ref2.previousResultCount;

  if (!isOpen) {
    return '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */


function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ?
  /* istanbul ignore next (preact) */
  arg[0] : arg;

  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */


function isDOMElement(element) {


  return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */


function getElementProps(element) {

  return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */


function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */

function pickState(state) {
  if (state === void 0) {
    state = {};
  }

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */


function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */


function isControlledProp(props, key) {
  return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */


function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */


function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */


function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }

  if (itemCount === 0) {
    return -1;
  }

  var itemsLastIndex = itemCount - 1;

  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }

  var newIndex = baseIndex + moveAmount;

  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }

  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);

  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }

  return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */


function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);

  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }

  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) {
      if (!getItemNodeFromIndex(index).hasAttribute('disabled')) {
        return index;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) {
        return _index;
      }
    }
  }

  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }

  return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */


function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }

  return downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
} // eslint-disable-next-line import/no-mutable-exports


var validateControlledUnchanged = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  validateControlledUnchanged = function validateControlledUnchanged(state, prevProps, nextProps) {
    var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
    Object.keys(state).forEach(function (propKey) {
      if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
      } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
      }
    });
  };
}

var cleanupStatus = debounce(function (documentProp) {
  getStatusDiv(documentProp).textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);

  if (!status) {
    return;
  }

  div.textContent = status;
  cleanupStatus(documentProp);
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */


function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }

  var statusDiv = documentProp.getElementById('a11y-status-message');

  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

var unknown = process.env.NODE_ENV !== "production" ? '__autocomplete_unknown__' : 0;
var mouseUp = process.env.NODE_ENV !== "production" ? '__autocomplete_mouseup__' : 1;
var itemMouseEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_item_mouseenter__' : 2;
var keyDownArrowUp = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_up__' : 3;
var keyDownArrowDown = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_down__' : 4;
var keyDownEscape = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_escape__' : 5;
var keyDownEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_enter__' : 6;
var keyDownHome = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_home__' : 7;
var keyDownEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_end__' : 8;
var clickItem = process.env.NODE_ENV !== "production" ? '__autocomplete_click_item__' : 9;
var blurInput = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_input__' : 10;
var changeInput = process.env.NODE_ENV !== "production" ? '__autocomplete_change_input__' : 11;
var keyDownSpaceButton = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_space_button__' : 12;
var clickButton = process.env.NODE_ENV !== "production" ? '__autocomplete_click_button__' : 13;
var blurButton = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_button__' : 14;
var controlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
var touchEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_touchend__' : 16;

var stateChangeTypes$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

var _excluded$4 = ["refKey", "ref"],
    _excluded2$3 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
    _excluded3$2 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
    _excluded4$1 = ["refKey", "ref"],
    _excluded5$1 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"];

var Downshift = /*#__PURE__*/function () {
  var Downshift = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Downshift, _Component);

    function Downshift(_props) {
      var _this;

      _this = _Component.call(this, _props) || this; // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided

      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";

      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };

      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];

      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);

        _this.timeoutIds.push(id);
      };

      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };

      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };

      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }

        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(_extends({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };

      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };

      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(_extends({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };

      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];

        if (item == null) {
          return;
        }

        _this.selectItem(item, otherStateToSet, cb);
      };

      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };

      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.

        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), stateToSet));
        }

        return _this.setState(function (state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.

          newStateToSet = _this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called

          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState

          var nextState = {}; // this is just used to tell whether the state changed

          var nextFullState = {}; // we need to call on change if the outside world is controlling any of our state
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection

          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }

          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            } // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.


            if (key === 'type') {
              return;
            }

            nextFullState[key] = newStateToSet[key]; // if it's coming from props, then we don't care to set it internally

            if (!isControlledProp(_this.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.

          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), newStateToSet));
          }

          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.

          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;

          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }

          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }

          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          } // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.


          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };

      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };

      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;

        var _ref = _temp === void 0 ? {} : _temp,
            _ref$refKey = _ref.refKey,
            refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
            ref = _ref.ref,
            rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);

        var _ref2 = _temp2 === void 0 ? {} : _temp2,
            _ref2$suppressRefErro = _ref2.suppressRefError,
            suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;

        var _this$getState = _this.getState(),
            isOpen = _this$getState.isOpen;

        return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };

      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();

              if (itemCount > 0) {
                var _this2$getState = _this2.getState(),
                    highlightedIndex = _this2$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function (index) {
                  return _this2.getItemNodeFromIndex(index);
                });

                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();

              if (itemCount > 0) {
                var _this3$getState = _this3.getState(),
                    highlightedIndex = _this3$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function (index) {
                  return _this3.getItemNodeFromIndex(index);
                });

                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }

          var _this$getState2 = this.getState(),
              isOpen = _this$getState2.isOpen,
              highlightedIndex = _this$getState2.highlightedIndex;

          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);

            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }

            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(_extends({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ''
          }));
        }
      };
      _this.buttonKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          var _this4 = this;

          var _this$getState3 = this.getState(),
              isOpen = _this$getState3.isOpen;

          if (!isOpen) {
            return;
          }

          event.preventDefault();
          var itemCount = this.getItemCount();

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting downwards from 0 if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function (index) {
            return _this4.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this5 = this;

          var _this$getState4 = this.getState(),
              isOpen = _this$getState4.isOpen;

          if (!isOpen) {
            return;
          }

          event.preventDefault();
          var itemCount = this.getItemCount();

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting upwards from last index if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function (index) {
            return _this5.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });

      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
            onClick = _ref3.onClick;
            _ref3.onPress;
            var onKeyDown = _ref3.onKeyDown,
            onKeyUp = _ref3.onKeyUp,
            onBlur = _ref3.onBlur,
            rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$3);

        var _this$getState5 = _this.getState(),
            isOpen = _this$getState5.isOpen;

        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return _extends({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, rest);
      };

      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };

      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.buttonHandleClick = function (event) {
        event.preventDefault(); // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.

        /* istanbul ignore if (can't reasonably test this) */

        if (_this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.


        if (process.env.NODE_ENV === 'test') {
          _this.toggleMenu({
            type: clickButton
          });
        } else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };

      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element

        _this.internalSetTimeout(function () {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
            _this.reset({
              type: blurButton
            });
          }
        });
      };

      _this.getLabelProps = function (props) {
        return _extends({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };

      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
            onKeyDown = _ref4.onKeyDown,
            onBlur = _ref4.onBlur,
            onChange = _ref4.onChange,
            onInput = _ref4.onInput;
            _ref4.onChangeText;
            var rest = _objectWithoutPropertiesLoose(_ref4, _excluded3$2);

        var onChangeKey;
        var eventHandlers = {};
        /* istanbul ignore next (preact) */

        {
          onChangeKey = 'onChange';
        }

        var _this$getState6 = _this.getState(),
            inputValue = _this$getState6.inputValue,
            isOpen = _this$getState6.isOpen,
            highlightedIndex = _this$getState6.highlightedIndex;

        if (!rest.disabled) {
          var _eventHandlers;

          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }

        return _extends({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, rest);
      };

      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };

      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);

          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };

      _this.menuRef = function (node) {
        _this._menuNode = node;
      };

      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;

        var _ref5 = _temp5 === void 0 ? {} : _temp5,
            _ref5$refKey = _ref5.refKey,
            refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
            ref = _ref5.ref,
            props = _objectWithoutPropertiesLoose(_ref5, _excluded4$1);

        var _ref6 = _temp6 === void 0 ? {} : _temp6,
            _ref6$suppressRefErro = _ref6.suppressRefError,
            suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;

        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };

      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;

        var _ref7 = _temp7 === void 0 ? {} : _temp7,
            onMouseMove = _ref7.onMouseMove,
            onMouseDown = _ref7.onMouseDown,
            onClick = _ref7.onClick;
            _ref7.onPress;
            var index = _ref7.index,
            _ref7$item = _ref7.item,
            item = _ref7$item === void 0 ? process.env.NODE_ENV === 'production' ?
        /* istanbul ignore next */
        undefined : requiredProp('getItemProps', 'item') : _ref7$item,
            rest = _objectWithoutPropertiesLoose(_ref7, _excluded5$1);

        if (index === undefined) {
          _this.items.push(item);

          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }

        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }

            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            }); // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor


            _this.avoidScrolling = true;

            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers); // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items

        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return _extends({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, rest);
      };

      _this.clearItems = function () {
        _this.items = [];
      };

      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return _extends({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };

      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return _extends({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, otherStateToSet);
        }, function () {
          var _this$getState7 = _this.getState(),
              isOpen = _this$getState7.isOpen,
              highlightedIndex = _this$getState7.highlightedIndex;

          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }

          cbToCb(cb)();
        });
      };

      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };

      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };

      _this.updateStatus = debounce(function () {
        var state = _this.getState();

        var item = _this.items[state.highlightedIndex];

        var resultCount = _this.getItemCount();

        var status = _this.props.getA11yStatusMessage(_extends({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));

        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);

      var _this$props = _this.props,
          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
          _this$props$initialHi = _this$props.initialHighlightedIndex,
          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
          defaultIsOpen = _this$props.defaultIsOpen,
          _this$props$initialIs = _this$props.initialIsOpen,
          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
          _this$props$initialIn = _this$props.initialInputValue,
          _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
          _this$props$initialSe = _this$props.initialSelectedItem,
          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;

      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });

      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }

      _this.state = _state;
      return _this;
    }

    var _proto = Downshift.prototype;

    /**
     * Clear all running timeouts
     */
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }
    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    ;

    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }

      return getState(stateToMerge, this.props);
    };

    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;

      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }

      return itemCount;
    };

    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };

    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };

    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var _this6 = this;

      var itemCount = this.getItemCount();

      var _this$getState8 = this.getState(),
          highlightedIndex = _this$getState8.highlightedIndex;

      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function (index) {
          return _this6.getItemNodeFromIndex(index);
        });
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };

    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(),
          highlightedIndex = _this$getState9.highlightedIndex,
          inputValue = _this$getState9.inputValue,
          selectedItem = _this$getState9.selectedItem,
          isOpen = _this$getState9.isOpen;

      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    } //////////////////////////// ROOT
    ;

    _proto.componentDidMount = function componentDidMount() {
      var _this7 = this;

      /* istanbul ignore if (react-native) */
      if (process.env.NODE_ENV !== 'production' && !false && this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
        validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
      }
      /* istanbul ignore if (react-native) */


      {
        // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.
        var onMouseDown = function onMouseDown() {
          _this7.isMouseDown = true;
        };

        var onMouseUp = function onMouseUp(event) {
          _this7.isMouseDown = false; // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift

          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment);

          if (!contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: mouseUp
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        }; // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping


        var onTouchStart = function onTouchStart() {
          _this7.isTouchMove = false;
        };

        var onTouchMove = function onTouchMove() {
          _this7.isTouchMove = true;
        };

        var onTouchEnd = function onTouchEnd(event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment, false);

          if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: touchEnd
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };

        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);

        this.cleanup = function () {
          _this7.internalClearTimeouts();

          _this7.updateStatus.cancel();

          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };

    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
          currentHighlightedIndex = _ref10.highlightedIndex;

      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
          prevHighlightedIndex = _ref11.highlightedIndex;

      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
      return scrollWhenOpen || scrollWhenNavigating;
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== 'production') {
        validateControlledUnchanged(this.state, prevProps, this.props);
        /* istanbul ignore if (react-native) */

        if (this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
        }
      }

      if (isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      /* istanbul ignore else (react-native) */


      {
        this.updateStatus();
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };

    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.

      this.clearItems(); // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.

      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps

      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps

      this.getLabelProps.called = false; // and something similar for getInputProps

      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));

      if (!element) {
        return null;
      }

      if (this.getRootProps.called || this.props.suppressRefError) {
        if (process.env.NODE_ENV !== 'production' && !this.getRootProps.suppressRefError && !this.props.suppressRefError) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }

        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return /*#__PURE__*/cloneElement(element, this.getRootProps(getElementProps(element)));
      }
      /* istanbul ignore else */


      if (process.env.NODE_ENV !== 'production') {
        // they didn't apply the root props, but they need to
        // otherwise we can't query around the autocomplete
        throw new Error('downshift: If you return a non-DOM element, you must apply the getRootProps function');
      }
      /* istanbul ignore next */


      return undefined;
    };

    return Downshift;
  }(Component);

  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage$1,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }

      if (process.env.NODE_ENV !== 'production' && isPlainObject(i) && !i.hasOwnProperty('toString')) {
        // eslint-disable-next-line no-console
        console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
      }

      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment:
    /* istanbul ignore next (ssr) */
    typeof window === 'undefined' ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes$3;
  return Downshift;
}();

process.env.NODE_ENV !== "production" ? Downshift.propTypes = {
  children: PropTypes.func,
  defaultHighlightedIndex: PropTypes.number,
  defaultIsOpen: PropTypes.bool,
  initialHighlightedIndex: PropTypes.number,
  initialSelectedItem: PropTypes.any,
  initialInputValue: PropTypes.string,
  initialIsOpen: PropTypes.bool,
  getA11yStatusMessage: PropTypes.func,
  itemToString: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onStateChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  onUserAction: PropTypes.func,
  onOuterClick: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  stateReducer: PropTypes.func,
  itemCount: PropTypes.number,
  id: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  }),
  suppressRefError: PropTypes.bool,
  scrollIntoView: PropTypes.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components

  /* eslint-disable react/no-unused-prop-types */
  selectedItem: PropTypes.any,
  isOpen: PropTypes.bool,
  inputValue: PropTypes.string,
  highlightedIndex: PropTypes.number,
  labelId: PropTypes.string,
  inputId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func
  /* eslint-enable react/no-unused-prop-types */

} : void 0;

function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;

  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}

function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);

  if (isComposite && !refKeySpecified && !reactIs.isForwardRef(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }

  if (!reactIs.isForwardRef(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

var _excluded$3 = ["isInitialMount", "highlightedIndex", "items", "environment"];
var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ''
};

function callOnChangeProps(action, state, newState) {
  var props = action.props,
      type = action.type;
  var changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, action, state, newState);

    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });

  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(_extends({
      type: type
    }, changes));
  }
}

function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props,
      type = action.type;
  var handler = "on" + capitalizeString(key) + "Change";

  if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) {
    props[handler](_extends({
      type: type
    }, newState));
  }
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */


function stateReducer(s, a) {
  return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : '';
}
/**
 * Debounced call for updating the a11y message.
 */


var updateA11yStatus = debounce(function (getA11yMessage, document) {
  setStatus(getA11yMessage(), document);
}, 200); // istanbul ignore next

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function useElementIds(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? "downshift-" + generateId() : _ref$id,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      getItemId = _ref.getItemId,
      toggleButtonId = _ref.toggleButtonId,
      inputId = _ref.inputId;
  var elementIdsRef = useRef({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function (index) {
      return id + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
}

function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }

  if (items.length === 0) {
    return -1;
  }

  return items.indexOf(item);
}

function itemToString(item) {
  return item ? String(item) : '';
}

function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}

function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}

function useLatestRef(val) {
  var ref = useRef(val); // technically this is not "concurrent mode safe" because we're manipulating
  // the value during render (so it's not idempotent). However, the places this
  // hook is used is to support memoizing callbacks which will be called
  // *during* render, so we need the latest values *during* render.
  // If not for this, then we'd probably want to use useLayoutEffect instead.

  ref.current = val;
  return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */


function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = useRef();
  var actionRef = useRef();
  var enhancedReducer = useCallback(function (state, action) {
    actionRef.current = action;
    state = getState(state, action.props);
    var changes = reducer(state, action);
    var newState = action.props.stateReducer(state, _extends({}, action, {
      changes: changes
    }));
    return newState;
  }, [reducer]);

  var _useReducer = useReducer(enhancedReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var propsRef = useLatestRef(props);
  var dispatchWithProps = useCallback(function (action) {
    return dispatch(_extends({
      props: propsRef.current
    }, action));
  }, [propsRef]);
  var action = actionRef.current;
  useEffect(function () {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, getState(prevStateRef.current, action.props), state);
    }

    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */


function useControlledReducer$1(reducer, initialState, props) {
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
      state = _useEnhancedReducer[0],
      dispatch = _useEnhancedReducer[1];

  return [getState(state, props), dispatch];
}

var defaultProps$3 = {
  itemToString: itemToString,
  stateReducer: stateReducer,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  circularNavigation: false,
  environment:
  /* istanbul ignore next (ssr) */
  typeof window === 'undefined' ? {} : window
};

function getDefaultValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  var defaultPropKey = "default" + capitalizeString(propKey);

  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }

  return defaultStateValues[propKey];
}

function getInitialValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  if (propKey in props) {
    return props[propKey];
  }

  var initialPropKey = "initial" + capitalizeString(propKey);

  if (initialPropKey in props) {
    return props[initialPropKey];
  }

  return getDefaultValue$1(props, propKey, defaultStateValues);
}

function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, 'selectedItem');
  var isOpen = getInitialValue$1(props, 'isOpen');
  var highlightedIndex = getInitialValue$1(props, 'highlightedIndex');
  var inputValue = getInitialValue$1(props, 'inputValue');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

function getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
  var items = props.items,
      initialHighlightedIndex = props.initialHighlightedIndex,
      defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex;

  if (items.length === 0) {
    return -1;
  } // initialHighlightedIndex will give value to highlightedIndex on initial state only.


  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }

  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }

  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }

    return getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
  }

  if (offset === 0) {
    return -1;
  }

  return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */


function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = useRef({
    isMouseDown: false,
    isTouchMove: false
  });
  useEffect(function () {
    // The same strategy for checking if a click occurred inside or outside downsift
    // as in downshift.js.
    var onMouseDown = function onMouseDown() {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };

    var onMouseUp = function onMouseUp(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;

      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment)) {
        handleBlur();
      }
    };

    var onTouchStart = function onTouchStart() {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };

    var onTouchMove = function onTouchMove() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };

    var onTouchEnd = function onTouchEnd(event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment, false)) {
        handleBlur();
      }
    };

    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);
    return function cleanup() {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */
// eslint-disable-next-line import/no-mutable-exports


var useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
  return noop;
};
/**
 * Custom hook that checks if getter props are called correctly.
 *
 * @param  {...any} propKeys Getter prop names to be handled.
 * @returns {Function} Setter function called inside getter props to set call information.
 */

/* istanbul ignore next */


if (process.env.NODE_ENV !== 'production') {
  useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    var isInitialMountRef = useRef(true);

    for (var _len = arguments.length, propKeys = new Array(_len), _key = 0; _key < _len; _key++) {
      propKeys[_key] = arguments[_key];
    }

    var getterPropsCalledRef = useRef(propKeys.reduce(function (acc, propKey) {
      acc[propKey] = {};
      return acc;
    }, {}));
    useEffect(function () {
      Object.keys(getterPropsCalledRef.current).forEach(function (propKey) {
        var propCallInfo = getterPropsCalledRef.current[propKey];

        if (isInitialMountRef.current) {
          if (!Object.keys(propCallInfo).length) {
            // eslint-disable-next-line no-console
            console.error("downshift: You forgot to call the " + propKey + " getter function on your component / element.");
            return;
          }
        }

        var suppressRefError = propCallInfo.suppressRefError,
            refKey = propCallInfo.refKey,
            elementRef = propCallInfo.elementRef;

        if ((!elementRef || !elementRef.current) && !suppressRefError) {
          // eslint-disable-next-line no-console
          console.error("downshift: The ref prop \"" + refKey + "\" from " + propKey + " was not applied correctly on your element.");
        }
      });
      isInitialMountRef.current = false;
    });
    var setGetterPropCallInfo = useCallback(function (propKey, suppressRefError, refKey, elementRef) {
      getterPropsCalledRef.current[propKey] = {
        suppressRefError: suppressRefError,
        refKey: refKey,
        elementRef: elementRef
      };
    }, []);
    return setGetterPropCallInfo;
  };
}

function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
  var isInitialMount = _ref2.isInitialMount,
      highlightedIndex = _ref2.highlightedIndex,
      items = _ref2.items,
      environment = _ref2.environment,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$3);

  // Sets a11y status message on changes in state.
  useEffect(function () {
    if (isInitialMount || false) {
      return;
    }

    updateA11yStatus(function () {
      return getA11yMessage(_extends({
        highlightedIndex: highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);
}

function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex,
      isOpen = _ref3.isOpen,
      itemRefs = _ref3.itemRefs,
      getItemNodeFromIndex = _ref3.getItemNodeFromIndex,
      menuElement = _ref3.menuElement,
      scrollIntoViewProp = _ref3.scrollIntoView;
  // used not to scroll on highlight by mouse.
  var shouldScrollRef = useRef(true); // Scroll on highlighted item if change comes from keyboard.

  useIsomorphicLayoutEffect(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }

    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  return shouldScrollRef;
} // eslint-disable-next-line import/no-mutable-exports


var useControlPropsValidator = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  useControlPropsValidator = function useControlPropsValidator(_ref4) {
    var isInitialMount = _ref4.isInitialMount,
        props = _ref4.props,
        state = _ref4.state;
    // used for checking when props are moving from controlled to uncontrolled.
    var prevPropsRef = useRef(props);
    useEffect(function () {
      if (isInitialMount) {
        return;
      }

      validateControlledUnchanged(state, prevPropsRef.current, props);
      prevPropsRef.current = props;
    }, [state, props, isInitialMount]);
  };
}

/* eslint-disable complexity */

function downshiftCommonReducer(state, action, stateChangeTypes) {
  var type = action.type,
      props = action.props;
  var changes;

  switch (type) {
    case stateChangeTypes.ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case stateChangeTypes.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;

    case stateChangeTypes.ToggleButtonClick:
    case stateChangeTypes.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case stateChangeTypes.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case stateChangeTypes.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;

    case stateChangeTypes.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case stateChangeTypes.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;

    case stateChangeTypes.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        isOpen: getDefaultValue$1(props, 'isOpen'),
        selectedItem: getDefaultValue$1(props, 'selectedItem'),
        inputValue: getDefaultValue$1(props, 'inputValue')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return _extends({}, state, changes);
}
/* eslint-enable complexity */

function getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for (var index = 0; index < items.length; index++) {
        var offsetIndex = (index + highlightedIndex + 1) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined &&
            itemToString(item)
                .toLowerCase()
                .startsWith(lowerCasedKeysSoFar)) {
            var element = getItemNodeFromIndex(offsetIndex);
            if (!(element === null || element === void 0 ? void 0 : element.hasAttribute('disabled'))) {
                return offsetIndex;
            }
        }
    }
    return highlightedIndex;
}
var propTypes$2 = {
    items: PropTypes.array.isRequired,
    itemToString: PropTypes.func,
    getA11yStatusMessage: PropTypes.func,
    getA11ySelectionMessage: PropTypes.func,
    circularNavigation: PropTypes.bool,
    highlightedIndex: PropTypes.number,
    defaultHighlightedIndex: PropTypes.number,
    initialHighlightedIndex: PropTypes.number,
    isOpen: PropTypes.bool,
    defaultIsOpen: PropTypes.bool,
    initialIsOpen: PropTypes.bool,
    selectedItem: PropTypes.any,
    initialSelectedItem: PropTypes.any,
    defaultSelectedItem: PropTypes.any,
    id: PropTypes.string,
    labelId: PropTypes.string,
    menuId: PropTypes.string,
    getItemId: PropTypes.func,
    toggleButtonId: PropTypes.string,
    stateReducer: PropTypes.func,
    onSelectedItemChange: PropTypes.func,
    onHighlightedIndexChange: PropTypes.func,
    onStateChange: PropTypes.func,
    onIsOpenChange: PropTypes.func,
    environment: PropTypes.shape({
        addEventListener: PropTypes.func,
        removeEventListener: PropTypes.func,
        document: PropTypes.shape({
            getElementById: PropTypes.func,
            activeElement: PropTypes.any,
            body: PropTypes.any
        })
    })
};
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */
function getA11yStatusMessage(_a) {
    var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
    if (!isOpen) {
        return '';
    }
    if (!resultCount) {
        return 'No results are available.';
    }
    if (resultCount !== previousResultCount) {
        return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.";
    }
    return '';
}
var defaultProps$2 = __assign(__assign({}, defaultProps$3), { getA11yStatusMessage: getA11yStatusMessage });
// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes$2 = noop;
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
    validatePropTypes$2 = function (options, caller) {
        PropTypes.checkPropTypes(propTypes$2, options, 'prop', caller.name);
    };
}

var MenuKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_down__' : 0;
var MenuKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_up__' : 1;
var MenuKeyDownEscape = process.env.NODE_ENV !== "production" ? '__menu_keydown_escape__' : 2;
var MenuKeyDownHome = process.env.NODE_ENV !== "production" ? '__menu_keydown_home__' : 3;
var MenuKeyDownEnd = process.env.NODE_ENV !== "production" ? '__menu_keydown_end__' : 4;
var MenuKeyDownEnter = process.env.NODE_ENV !== "production" ? '__menu_keydown_enter__' : 5;
var MenuKeyDownSpaceButton = process.env.NODE_ENV !== "production" ? '__menu_keydown_space_button__' : 6;
var MenuKeyDownCharacter = process.env.NODE_ENV !== "production" ? '__menu_keydown_character__' : 7;
var MenuBlur = process.env.NODE_ENV !== "production" ? '__menu_blur__' : 8;
var MenuMouseLeave$1 = process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 9;
var ItemMouseMove$1 = process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 10;
var ItemClick$1 = process.env.NODE_ENV !== "production" ? '__item_click__' : 11;
var ToggleButtonClick$1 = process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 12;
var ToggleButtonKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_down__' : 13;
var ToggleButtonKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_up__' : 14;
var ToggleButtonKeyDownCharacter = process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_character__' : 15;
var FunctionToggleMenu$1 = process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 16;
var FunctionOpenMenu$1 = process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 17;
var FunctionCloseMenu$1 = process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 18;
var FunctionSetHighlightedIndex$1 = process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 19;
var FunctionSelectItem$1 = process.env.NODE_ENV !== "production" ? '__function_select_item__' : 20;
var FunctionSetInputValue$1 = process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 21;
var FunctionReset$2 = process.env.NODE_ENV !== "production" ? '__function_reset__' : 22;

var stateChangeTypes$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown: MenuKeyDownArrowDown,
  MenuKeyDownArrowUp: MenuKeyDownArrowUp,
  MenuKeyDownEscape: MenuKeyDownEscape,
  MenuKeyDownHome: MenuKeyDownHome,
  MenuKeyDownEnd: MenuKeyDownEnd,
  MenuKeyDownEnter: MenuKeyDownEnter,
  MenuKeyDownSpaceButton: MenuKeyDownSpaceButton,
  MenuKeyDownCharacter: MenuKeyDownCharacter,
  MenuBlur: MenuBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  ToggleButtonClick: ToggleButtonClick$1,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionReset: FunctionReset$2
});

/* eslint-disable complexity */

function downshiftSelectReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index]
      };
      break;

    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var inputValue = "" + state.inputValue + lowercasedKey;
        var itemIndex = getItemIndexByCharacterKey({
          keysSoFar: inputValue,
          highlightedIndex: state.selectedItem ? props.items.indexOf(state.selectedItem) : -1,
          items: props.items,
          itemToString: props.itemToString,
          getItemNodeFromIndex: action.getItemNodeFromIndex
        });
        changes = _extends({
          inputValue: inputValue
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;

    case ToggleButtonKeyDownArrowDown:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;

    case ToggleButtonKeyDownArrowUp:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;

    case MenuKeyDownEnter:
    case MenuKeyDownSpaceButton:
      changes = _extends({
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex')
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;

    case MenuKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuBlur:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownCharacter:
      {
        var _lowercasedKey = action.key;

        var _inputValue = "" + state.inputValue + _lowercasedKey;

        var highlightedIndex = getItemIndexByCharacterKey({
          keysSoFar: _inputValue,
          highlightedIndex: state.highlightedIndex,
          items: props.items,
          itemToString: props.itemToString,
          getItemNodeFromIndex: action.getItemNodeFromIndex
        });
        changes = _extends({
          inputValue: _inputValue
        }, highlightedIndex >= 0 && {
          highlightedIndex: highlightedIndex
        });
      }
      break;

    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem
      };
      break;

    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$2);
  }

  return _extends({}, state, changes);
}
/* eslint-enable complexity */

var _excluded$2 = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"],
    _excluded2$2 = ["onClick", "onKeyDown", "refKey", "ref"],
    _excluded3$1 = ["item", "index", "onMouseMove", "onClick", "refKey", "ref"];
useSelect.stateChangeTypes = stateChangeTypes$2;

function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  validatePropTypes$2(userProps, useSelect); // Props defaults and destructuring.

  var props = _extends({}, defaultProps$2, userProps);

  var items = props.items,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment,
      initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      itemToString = props.itemToString,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      getA11yStatusMessage = props.getA11yStatusMessage; // Initial state depending on controlled props.

  var initialState = getInitialState$2(props);

  var _useControlledReducer = useControlledReducer$1(downshiftSelectReducer, initialState, props),
      state = _useControlledReducer[0],
      dispatch = _useControlledReducer[1];

  var isOpen = state.isOpen,
      highlightedIndex = state.highlightedIndex,
      selectedItem = state.selectedItem,
      inputValue = state.inputValue; // Element efs.

  var toggleButtonRef = useRef(null);
  var menuRef = useRef(null);
  var itemRefs = useRef({}); // used not to trigger menu blur action in some scenarios.

  var shouldBlurRef = useRef(true); // used to keep the inputValue clearTimeout object between renders.

  var clearTimeoutRef = useRef(null); // prevent id re-generation between renders.

  var elementIds = useElementIds(props); // used to keep track of how many items we had on previous cycle.

  var previousResultCountRef = useRef();
  var isInitialMountRef = useRef(true); // utility callback to get item element.

  var latest = useLatestRef({
    state: state,
    props: props
  }); // Some utils.

  var getItemNodeFromIndex = useCallback(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]); // Effects.
  // Sets a11y status message on changes in state.

  useA11yMessageSetter(getA11yStatusMessage, [isOpen, highlightedIndex, inputValue, items], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Sets a11y status message on changes in selectedItem.

  useA11yMessageSetter(getA11ySelectionMessage, [selectedItem], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Scroll on highlighted item if change comes from keyboard.

  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  }); // Sets cleanup for the keysSoFar callback, debounded after 500ms.

  useEffect(function () {
    // init the clean function here as we need access to dispatch.
    clearTimeoutRef.current = debounce(function (outerDispatch) {
      outerDispatch({
        type: FunctionSetInputValue$1,
        inputValue: ''
      });
    }, 500); // Cancel any pending debounced calls on mount

    return function () {
      clearTimeoutRef.current.cancel();
    };
  }, []); // Invokes the keysSoFar callback set up above.

  useEffect(function () {
    if (!inputValue) {
      return;
    }

    clearTimeoutRef.current(dispatch);
  }, [dispatch, inputValue]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  });
  /* Controls the focus on the menu or the toggle button. */

  useEffect(function () {
    // Don't focus menu on first render.
    if (isInitialMountRef.current) {
      // Unless it was initialised as open.
      if ((initialIsOpen || defaultIsOpen || isOpen) && menuRef.current) {
        menuRef.current.focus();
      }

      return;
    } // Focus menu on open.


    if (isOpen) {
      // istanbul ignore else
      if (menuRef.current) {
        menuRef.current.focus();
      }

      return;
    } // Focus toggleButton on close, but not if it was closed with (Shift+)Tab.


    if (environment.document.activeElement === menuRef.current) {
      // istanbul ignore else
      if (toggleButtonRef.current) {
        shouldBlurRef.current = false;
        toggleButtonRef.current.focus();
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    previousResultCountRef.current = items.length;
  }); // Add mouse/touch events to document.

  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: MenuBlur
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps'); // Make initial ref false.

  useEffect(function () {
    isInitialMountRef.current = false;
  }, []); // Reset itemRefs on close.

  useEffect(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]); // Event handler functions.

  var toggleButtonKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowDown,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowUp,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      }
    };
  }, [dispatch, getItemNodeFromIndex]);
  var menuKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownArrowDown,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownArrowUp,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      Home: function Home(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        dispatch({
          type: MenuKeyDownEscape
        });
      },
      Enter: function Enter(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownEnter
        });
      },
      ' ': function _(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownSpaceButton
        });
      }
    };
  }, [dispatch, getItemNodeFromIndex]); // Action functions.

  var toggleMenu = useCallback(function () {
    dispatch({
      type: FunctionToggleMenu$1
    });
  }, [dispatch]);
  var closeMenu = useCallback(function () {
    dispatch({
      type: FunctionCloseMenu$1
    });
  }, [dispatch]);
  var openMenu = useCallback(function () {
    dispatch({
      type: FunctionOpenMenu$1
    });
  }, [dispatch]);
  var setHighlightedIndex = useCallback(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = useCallback(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem$1,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset$2
    });
  }, [dispatch]);
  var setInputValue = useCallback(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue$1,
      inputValue: newInputValue
    });
  }, [dispatch]); // Getter functions.

  var getLabelProps = useCallback(function (labelProps) {
    return _extends({
      id: elementIds.labelId,
      htmlFor: elementIds.toggleButtonId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = useCallback(function (_temp, _temp2) {
    var _extends2;

    var _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
        onKeyDown = _ref.onKeyDown,
        onBlur = _ref.onBlur,
        ref = _ref.ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

    var latestState = latest.current.state;

    var menuHandleKeyDown = function menuHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && menuKeyDownHandlers[key]) {
        menuKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: MenuKeyDownCharacter,
          key: key,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };

    var menuHandleBlur = function menuHandleBlur() {
      // if the blur was a result of selection, we don't trigger this action.
      if (shouldBlurRef.current === false) {
        shouldBlurRef.current = true;
        return;
      }

      var shouldBlur = !mouseAndTouchTrackersRef.current.isMouseDown;
      /* istanbul ignore else */

      if (shouldBlur) {
        dispatch({
          type: MenuBlur
        });
      }
    };

    var menuHandleMouseLeave = function menuHandleMouseLeave() {
      dispatch({
        type: MenuMouseLeave$1
      });
    };

    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = elementIds.labelId, _extends2.tabIndex = -1, _extends2), latestState.isOpen && latestState.highlightedIndex > -1 && {
      'aria-activedescendant': elementIds.getItemId(latestState.highlightedIndex)
    }, {
      onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave),
      onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
      onBlur: callAllEventHandlers(onBlur, menuHandleBlur)
    }, rest);
  }, [dispatch, latest, menuKeyDownHandlers, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]);
  var getToggleButtonProps = useCallback(function (_temp3, _temp4) {
    var _extends3;

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        onClick = _ref3.onClick,
        onKeyDown = _ref3.onKeyDown,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
        ref = _ref3.ref,
        rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$2);

    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        _ref4$suppressRefErro = _ref4.suppressRefError,
        suppressRefError = _ref4$suppressRefErro === void 0 ? false : _ref4$suppressRefErro;

    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick$1
      });
    };

    var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && toggleButtonKeyDownHandlers[key]) {
        toggleButtonKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: ToggleButtonKeyDownCharacter,
          key: key,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };

    var toggleProps = _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends3.id = elementIds.toggleButtonId, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-expanded'] = latest.current.state.isOpen, _extends3['aria-labelledby'] = elementIds.labelId + " " + elementIds.toggleButtonId, _extends3), rest);

    if (!rest.disabled) {
      toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
      toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
    }

    setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
    return toggleProps;
  }, [dispatch, latest, toggleButtonKeyDownHandlers, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]);
  var getItemProps = useCallback(function (_temp5) {
    var _extends4;

    var _ref5 = _temp5 === void 0 ? {} : _temp5,
        item = _ref5.item,
        index = _ref5.index,
        onMouseMove = _ref5.onMouseMove,
        onClick = _ref5.onClick,
        _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
        ref = _ref5.ref,
        rest = _objectWithoutPropertiesLoose(_ref5, _excluded3$1);

    var _latest$current = latest.current,
        latestState = _latest$current.state,
        latestProps = _latest$current.props;

    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (index === latestState.highlightedIndex) {
        return;
      }

      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove$1,
        index: index
      });
    };

    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick$1,
        index: index
      });
    };

    var itemIndex = getItemIndex(index, item, latestProps.items);

    if (itemIndex < 0) {
      throw new Error('Pass either item or item index in getItemProps!');
    }

    var itemProps = _extends((_extends4 = {
      role: 'option',
      'aria-selected': "" + (itemIndex === latestState.highlightedIndex),
      id: elementIds.getItemId(itemIndex)
    }, _extends4[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
      }
    }), _extends4), rest);

    if (!rest.disabled) {
      itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove);
      itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick);
    }

    return itemProps;
  }, [dispatch, latest, shouldScrollRef, elementIds]);
  return {
    // prop getters.
    getToggleButtonProps: getToggleButtonProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getItemProps: getItemProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    selectItem: selectItem,
    reset: reset,
    setInputValue: setInputValue,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_down__' : 0;
process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_up__' : 1;
process.env.NODE_ENV !== "production" ? '__input_keydown_escape__' : 2;
process.env.NODE_ENV !== "production" ? '__input_keydown_home__' : 3;
process.env.NODE_ENV !== "production" ? '__input_keydown_end__' : 4;
process.env.NODE_ENV !== "production" ? '__input_keydown_enter__' : 5;
process.env.NODE_ENV !== "production" ? '__input_change__' : 6;
process.env.NODE_ENV !== "production" ? '__input_blur__' : 7;
process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 8;
process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 9;
process.env.NODE_ENV !== "production" ? '__item_click__' : 10;
process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 11;
process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 12;
process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 13;
process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 14;
process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 15;
process.env.NODE_ENV !== "production" ? '__function_select_item__' : 16;
process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 17;
process.env.NODE_ENV !== "production" ? '__function_reset__' : 18;
process.env.NODE_ENV !== "production" ? '__controlled_prop_updated_selected_item__' : 19;

({
  items: PropTypes.array.isRequired,
  itemToString: PropTypes.func,
  getA11yStatusMessage: PropTypes.func,
  getA11ySelectionMessage: PropTypes.func,
  circularNavigation: PropTypes.bool,
  highlightedIndex: PropTypes.number,
  defaultHighlightedIndex: PropTypes.number,
  initialHighlightedIndex: PropTypes.number,
  isOpen: PropTypes.bool,
  defaultIsOpen: PropTypes.bool,
  initialIsOpen: PropTypes.bool,
  selectedItem: PropTypes.any,
  initialSelectedItem: PropTypes.any,
  defaultSelectedItem: PropTypes.any,
  inputValue: PropTypes.string,
  defaultInputValue: PropTypes.string,
  initialInputValue: PropTypes.string,
  id: PropTypes.string,
  labelId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func,
  inputId: PropTypes.string,
  toggleButtonId: PropTypes.string,
  stateReducer: PropTypes.func,
  onSelectedItemChange: PropTypes.func,
  onHighlightedIndexChange: PropTypes.func,
  onStateChange: PropTypes.func,
  onIsOpenChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  })
});
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') ;

_extends({}, defaultProps$3, {
  getA11yStatusMessage: getA11yStatusMessage$1,
  circularNavigation: true
});
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(removedSelectedItem) + " has been removed.";
}

({
  selectedItems: PropTypes.array,
  initialSelectedItems: PropTypes.array,
  defaultSelectedItems: PropTypes.array,
  itemToString: PropTypes.func,
  getA11yRemovalMessage: PropTypes.func,
  stateReducer: PropTypes.func,
  activeIndex: PropTypes.number,
  initialActiveIndex: PropTypes.number,
  defaultActiveIndex: PropTypes.number,
  onActiveIndexChange: PropTypes.func,
  onSelectedItemsChange: PropTypes.func,
  keyNavigationNext: PropTypes.string,
  keyNavigationPrevious: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  })
});
({
  itemToString: defaultProps$3.itemToString,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  getA11yRemovalMessage: getA11yRemovalMessage,
  keyNavigationNext: 'ArrowRight',
  keyNavigationPrevious: 'ArrowLeft'
}); // eslint-disable-next-line import/no-mutable-exports
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') ;

process.env.NODE_ENV !== "production" ? '__selected_item_click__' : 0;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_delete__' : 1;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_backspace__' : 2;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_next__' : 3;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_previous__' : 4;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_navigation_previous__' : 5;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_backspace__' : 6;
process.env.NODE_ENV !== "production" ? '__dropdown_click__' : 7;
process.env.NODE_ENV !== "production" ? '__function_add_selected_item__' : 8;
process.env.NODE_ENV !== "production" ? '__function_remove_selected_item__' : 9;
process.env.NODE_ENV !== "production" ? '__function_set_selected_items__' : 10;
process.env.NODE_ENV !== "production" ? '__function_set_active_index__' : 11;
process.env.NODE_ENV !== "production" ? '__function_reset__' : 12;

var Label = function (_a) {
    var htmlFor = _a.htmlFor, className = _a.className, children = _a.children, other = __rest(_a, ["htmlFor", "className", "children"]);
    var controlId = useContext(FormGroupContext).controlId;
    var labelClasses = classnames('dl-form-control-label', className);
    return (React.createElement("label", __assign({ htmlFor: controlId !== null && controlId !== void 0 ? controlId : htmlFor, className: labelClasses }, other), children));
};

var Dropdown = function (_a) {
    var _b;
    var className = _a.className, disabled = _a.disabled, id = _a.id, items = _a.items, label = _a.label, placeholder = _a.placeholder, size = _a.size, selectedItem = _a.selectedItem, handleSelectedItemChange = _a.handleSelectedItemChange, other = __rest(_a, ["className", "disabled", "id", "items", "label", "placeholder", "size", "selectedItem", "handleSelectedItemChange"]);
    var _c = useSelect({
        items: items,
        selectedItem: selectedItem,
        onSelectedItemChange: handleSelectedItemChange,
    }), isOpen = _c.isOpen, getToggleButtonProps = _c.getToggleButtonProps, getLabelProps = _c.getLabelProps, getMenuProps = _c.getMenuProps, highlightedIndex = _c.highlightedIndex, getItemProps = _c.getItemProps;
    var dropdownClasses = classnames('dl-dropdown', (_b = {},
        _b["dl-dropdown-" + size] = size,
        _b.show = isOpen,
        _b['dl-dropdown-item-selected'] = !!selectedItem,
        _b['dl-dropdown-disabled'] = disabled,
        _b), className);
    var toggleClasses = classnames('dl-dropdown-toggle');
    var itemListStyles = classnames('dl-dropdown-item', {
        'dl-dropdown-item-disabled': disabled,
    }, className);
    var arrow = isOpen ? (React.createElement(Icon, { size: size === 'sm' ? 'sm' : 'md', name: "caret-up" })) : (React.createElement(Icon, { size: size === 'sm' ? 'sm' : 'md', name: "caret-down" }));
    return (React.createElement("div", __assign({ id: id, className: dropdownClasses }, other),
        label && React.createElement(Label, __assign({}, getLabelProps()), label),
        React.createElement("button", __assign({ type: "button", className: toggleClasses }, getToggleButtonProps()),
            React.createElement("span", { className: "dl-dropdown-toggle-title" }, (selectedItem && selectedItem.content) || placeholder),
            React.createElement("span", { className: "dl-arrow-container" }, arrow)),
        React.createElement("ul", __assign({ className: "dl-dropdown-menu" }, getMenuProps()), isOpen &&
            items.map(function (item, index) { return (React.createElement("li", __assign({ key: "" + item.id + index }, getItemProps({ item: item, index: index }), { className: [
                    itemListStyles,
                    highlightedIndex === index ? 'dl-dropdown-item-hover' : '',
                    item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) ? 'dl-dropdown-item-active' : '',
                ].join(' ') }),
                React.createElement("span", { className: "dl-dropdown-item-content" }, item.content),
                item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) && (React.createElement(Icon, { size: size === 'md' ? 'md' : 'sm', name: "check" })))); }))));
};
Dropdown.defaultProps = {
    size: 'md',
    disabled: false,
};

var FormGroup = function (_a) {
    var controlId = _a.controlId, children = _a.children, className = _a.className, other = __rest(_a, ["controlId", "children", "className"]);
    var classNameList = classnames('dl-form-group', className);
    return (React.createElement(FormGroupContext.Provider, { value: { controlId: controlId } },
        React.createElement("div", __assign({ className: classNameList }, other), children)));
};

var InputIcon = function (_a) {
    var children = _a.children, iconName = _a.iconName, iconSize = _a.iconSize, isInvalid = _a.isInvalid, isValid = _a.isValid, onClick = _a.onClick, showPassword = _a.showPassword;
    var classNameList = classnames('dl-input-icon-right');
    return (React.createElement("div", { className: classNameList },
        children,
        React.createElement("div", { className: "dl-icon-container" },
            React.createElement(Icon, { name: showPassword
                    ? iconName || ''
                    : isInvalid
                        ? 'x'
                        : isValid
                            ? 'check'
                            : iconName || '', size: iconSize, role: showPassword
                    ? 'button'
                    : iconName || isInvalid || isValid
                        ? 'img'
                        : '', onClick: onClick }))));
};
InputIcon.defaultProps = {
    iconSize: 'md',
    showPassword: false,
};

var Input = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var name = _a.name, type = _a.type, defaultValue = _a.defaultValue, value = _a.value, className = _a.className, size = _a.size, placeholder = _a.placeholder, ariaLabel = _a.ariaLabel, iconName = _a.iconName, showPassword = _a.showPassword, isValid = _a.isValid, isInvalid = _a.isInvalid, readOnly = _a.readOnly, onChange = _a.onChange, onBlur = _a.onBlur, onClick = _a.onClick, other = __rest(_a, ["name", "type", "defaultValue", "value", "className", "size", "placeholder", "ariaLabel", "iconName", "showPassword", "isValid", "isInvalid", "readOnly", "onChange", "onBlur", "onClick"]);
    var controlId = useContext(FormGroupContext).controlId;
    var _d = useState(false), filled = _d[0], setFilled = _d[1];
    var _e = useState(false), manageShowPassword = _e[0], setManageShowPassword = _e[1];
    var inputWrapperClasses = classnames('dl-form-control-container', (_b = {},
        _b["dl-form-control-container-" + size] = size,
        _b['dl-form-control-has-icon'] = iconName,
        _b));
    var inputClasses = classnames('dl-form-control', (_c = {},
        _c["dl-form-control-" + size] = size,
        _c['dl-is-valid'] = isValid,
        _c['dl-is-invalid'] = isInvalid,
        _c['dl-form-control-filled'] = filled,
        _c), className);
    var handleBlur = function (e) {
        setFilled(!!e.target.value.trim());
    };
    var inputElement = (React.createElement("input", __assign({ id: controlId || name, name: controlId || name, type: showPassword && manageShowPassword ? 'text' : type, value: value, defaultValue: defaultValue, className: inputClasses, "aria-label": ariaLabel, placeholder: placeholder, readOnly: readOnly, onChange: onChange, onClick: onClick, onBlur: function (e) {
            handleBlur(e);
            onBlur && onBlur(e);
        }, ref: ref }, other)));
    var handleIconClick = function () {
        setManageShowPassword(!manageShowPassword);
    };
    var input = (React.createElement(InputIcon, { iconName: showPassword && !manageShowPassword
            ? 'eye'
            : showPassword && manageShowPassword
                ? 'eye-slash'
                : iconName, iconSize: size, isInvalid: isInvalid, isValid: isValid, showPassword: showPassword, onClick: handleIconClick }, inputElement));
    return React.createElement("div", { className: inputWrapperClasses }, input);
});
Input.defaultProps = {
    type: 'text',
    size: 'md',
    isValid: false,
    isInvalid: false,
    disabled: false,
    readOnly: false,
    showPassword: false,
};
Input.displayName = 'Input';

var Textarea = React.forwardRef(function (_a, ref) {
    var name = _a.name, className = _a.className, defaultValue = _a.defaultValue, value = _a.value, placeholder = _a.placeholder, ariaLabel = _a.ariaLabel, isValid = _a.isValid, isInvalid = _a.isInvalid, readOnly = _a.readOnly, onChange = _a.onChange, onClick = _a.onClick, onBlur = _a.onBlur, other = __rest(_a, ["name", "className", "defaultValue", "value", "placeholder", "ariaLabel", "isValid", "isInvalid", "readOnly", "onChange", "onClick", "onBlur"]);
    var controlId = useContext(FormGroupContext).controlId;
    var _b = useState(false), filled = _b[0], setFilled = _b[1];
    var textareaWrapperClasses = classnames('dl-form-control-container dl-form-control-container-md');
    var textareaClasses = classnames('dl-form-control dl-form-control-md', {
        'dl-is-valid': isValid,
        'dl-is-invalid': isInvalid,
        'dl-form-control-filled': filled,
    }, className);
    var handleBlur = function (e) {
        setFilled(!!e.target.value.trim());
    };
    return (React.createElement("div", { className: textareaWrapperClasses },
        React.createElement("textarea", __assign({ id: controlId !== null && controlId !== void 0 ? controlId : name, name: controlId !== null && controlId !== void 0 ? controlId : name, className: textareaClasses, value: value, defaultValue: defaultValue, "aria-label": ariaLabel, placeholder: placeholder, readOnly: readOnly, onChange: onChange, onClick: onClick, onBlur: function (e) {
                handleBlur(e);
                onBlur && onBlur(e);
            }, ref: ref }, other))));
});
Textarea.defaultProps = {
    isValid: false,
    isInvalid: false,
    disabled: false,
    readOnly: false,
};
Textarea.displayName = 'Textarea';

var HelperText = function (_a) {
    var children = _a.children, className = _a.className, isValid = _a.isValid, isInvalid = _a.isInvalid, other = __rest(_a, ["children", "className", "isValid", "isInvalid"]);
    var containerClassNameList = classnames('dl-feedback-container', className);
    var feedbackClassNameList = classnames('dl-form-text', {
        'dl-valid-feedback': isValid,
        'dl-invalid-feedback': isInvalid,
    });
    return (React.createElement("div", __assign({ className: containerClassNameList }, other),
        React.createElement("div", { className: feedbackClassNameList }, children)));
};
HelperText.defaultProps = {
    isValid: false,
    isInvalid: false,
};

var SelectItem = function (_a) {
    var value = _a.value, disabled = _a.disabled, content = _a.content, other = __rest(_a, ["value", "disabled", "content"]);
    return (React.createElement("option", __assign({ value: value, disabled: disabled }, other), content));
};
SelectItem.defaultProps = { disabled: false };

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var Select = React.forwardRef(function (_a, ref) {
    var _b;
    var name = _a.name, size = _a.size, defaultValue = _a.defaultValue, value = _a.value, className = _a.className, isValid = _a.isValid, isInvalid = _a.isInvalid, disabled = _a.disabled, children = _a.children, onChange = _a.onChange, onBlur = _a.onBlur, onClick = _a.onClick, other = __rest(_a, ["name", "size", "defaultValue", "value", "className", "isValid", "isInvalid", "disabled", "children", "onChange", "onBlur", "onClick"]);
    var controlId = useContext(FormGroupContext).controlId;
    var _c = useState(false), selected = _c[0], isSelected = _c[1];
    var inputWrapperClasses = classnames('dl-select dl-form-control-container', (_b = {},
        _b["dl-form-control-container-" + size] = size,
        _b['dl-select-selected'] = selected,
        _b));
    var classNameList = classnames('dl-form-control dl-form-control-md', {
        'dl-is-valid': isValid,
        'dl-is-invalid': isInvalid,
    }, className);
    var handleChange = function (e) {
        e.target.value !== '' && e.target.value !== '0'
            ? isSelected(true)
            : isSelected(false);
    };
    return (React.createElement("div", { className: inputWrapperClasses },
        React.createElement("select", __assign({ id: controlId || name, name: controlId || name, value: value, className: classNameList, disabled: disabled, onChange: function (e) {
                handleChange(e);
                onChange && onChange(e);
            }, onClick: onClick, onBlur: onBlur, ref: ref, defaultValue: defaultValue }, other), children)));
});
Select.defaultProps = {
    size: 'md',
    isValid: false,
    isInvalid: false,
    disabled: false,
};
Select.Item = SelectItem;
Select.displayName = 'Select';

var Form = function (_a) {
    var children = _a.children, className = _a.className, other = __rest(_a, ["children", "className"]);
    var formClasses = classnames(className);
    return (React.createElement("form", __assign({ className: formClasses }, other), children));
};
Form.Group = FormGroup;
Form.Label = Label;
Form.Input = Input;
Form.Textarea = Textarea;
Form.HelperText = HelperText;
Form.Check = Check;
Form.Select = Select;

var Heading = function (_a) {
    var _b;
    var children = _a.children, _c = _a.as, as = _c === void 0 ? 'h1' : _c, _d = _a.size, size = _d === void 0 ? 'lg' : _d, className = _a.className, other = __rest(_a, ["children", "as", "size", "className"]);
    var HeadingClasses = classnames((_b = {},
        _b["dl-heading-" + size] = size,
        _b), className);
    var commonProps = {
        className: HeadingClasses,
    };
    var component = 'h1';
    as && (component = as);
    return React.createElement(component, __assign(__assign({}, commonProps), other), children);
};

var InputAmountIncrease = React.forwardRef(function (_a, ref) {
    var _b = _a.title, title = _b === void 0 ? 'Más' : _b, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, onClick = _a.onClick, onBlur = _a.onBlur, other = __rest(_a, ["title", "className", "disabled", "isLoading", "onClick", "onBlur"]);
    var classNameList = classnames(className);
    return (React.createElement(Button, __assign({ variant: "primary", className: classNameList, title: title, isIconOnly: true, iconName: "plus", iconWeight: "bold", size: "sm", ref: ref, disabled: disabled, isLoading: isLoading, onClick: onClick, onBlur: onBlur }, other)));
});
InputAmountIncrease.displayName = 'InputAmountIncrease';

var InputAmountDecrease = forwardRef(function (_a, ref) {
    var _b = _a.title, title = _b === void 0 ? 'Menos' : _b, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, onClick = _a.onClick, onBlur = _a.onBlur, other = __rest(_a, ["title", "className", "disabled", "isLoading", "onClick", "onBlur"]);
    var classNameList = classnames(className);
    return (React.createElement(Button, __assign({ variant: "secondary", title: title, className: classNameList, isIconOnly: true, iconName: "minus", size: "sm", ref: ref, disabled: disabled, onClick: onClick, onBlur: onBlur, isLoading: isLoading }, other)));
});
InputAmountDecrease.displayName = 'InputAmountDecrease';

var InputAmountInput = forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, value = _a.value, _c = _a.min, min = _c === void 0 ? 1 : _c, _d = _a.max, max = _d === void 0 ? 9999 : _d, className = _a.className, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, onChange = _a.onChange, onBlur = _a.onBlur, onClick = _a.onClick, _g = _a.isLoading, isLoading = _g === void 0 ? false : _g, other = __rest(_a, ["type", "value", "min", "max", "className", "readOnly", "disabled", "onChange", "onBlur", "onClick", "isLoading"]);
    var classNameList = classnames('dl-form-control dl-form-control-md dl-input-field', {
        'dl-is-disabled': isLoading || disabled,
    }, className);
    return (React.createElement("label", null,
        React.createElement("input", __assign({ className: classNameList, type: type, max: max, min: min, maxLength: max.toString().length, value: value, pattern: "[0-9]*", ref: ref, disabled: disabled || isLoading, readOnly: readOnly, onChange: onChange, onClick: onClick, onBlur: onBlur }, other))));
});
InputAmountInput.displayName = 'InputAmountInput';

var InputAmount = forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var classNameList = classnames('dl-input-amount', {}, className);
    return (React.createElement("div", __assign({ className: classNameList, ref: ref }, other), children));
});
InputAmount.BtnIncrease = InputAmountIncrease;
InputAmount.BtnDecrease = InputAmountDecrease;
InputAmount.Input = InputAmountInput;
InputAmount.displayName = 'InputAmount';

var Isotype = function (props) { return (React.createElement(Brand, __assign({ isotype: true }, props))); };
Isotype.defaultProps = {
    variant: 'alicorp',
    size: 'md',
    inverse: false,
};

var Link = React.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, variant = _a.variant, className = _a.className, href = _a.href, hasIcon = _a.hasIcon, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, disabled = _a.disabled, other = __rest(_a, ["children", "variant", "className", "href", "hasIcon", "onClick", "onFocus", "onBlur", "disabled"]);
    var classNameList = classnames('dl-link', (_b = {},
        _b["dl-link-" + variant] = variant,
        _b["dl-disabled"] = href && disabled,
        _b["dl-link-icon-" + hasIcon] = hasIcon,
        _b), className);
    var icon = function (arg) { return React.createElement(Icon, { name: arg, size: "sm" }); };
    return (React.createElement(Fragment$2, null, href ? (React.createElement("a", __assign({ className: classNameList, href: sanitizeUrl(href), onClick: onClick, onFocus: onFocus, onBlur: onBlur, rel: other.target === '_blank' ? 'noopener noreferrer' : undefined }, other),
        hasIcon === 'left' && icon('caret-left'),
        children,
        hasIcon === 'right' && icon('caret-right'))) : (React.createElement("button", __assign({ className: classNameList, disabled: disabled, onClick: onClick, onFocus: onFocus, onBlur: onBlur, ref: ref }, other),
        hasIcon === 'left' && icon('caret-left'),
        children,
        hasIcon === 'right' && icon('caret-right')))));
});
Link.displayName = 'Link';
Link.defaultProps = {
    variant: 'default',
    disabled: false,
};

var Logotype = function (props) { return React.createElement(Brand, __assign({}, props)); };
Logotype.defaultProps = {
    variant: 'alicorp',
    size: 'md',
    inverse: false,
};

var Navbar = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'center' : _c, children = _a.children, className = _a.className, other = __rest(_a, ["variant", "children", "className"]);
    var navList = classnames('dl-navbar', (_b = {},
        _b["dl-navbar-" + variant] = variant,
        _b), className);
    return (React.createElement("nav", __assign({ className: navList }, other), children));
};

var SearchBox = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.name, name = _c === void 0 ? 's' : _c, className = _a.className, value = _a.value, _d = _a.size, size = _d === void 0 ? 'md' : _d, placeholder = _a.placeholder, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? 'Buscador' : _e, onChange = _a.onChange, onClick = _a.onClick, onBlur = _a.onBlur, onDeleteContent = _a.onDeleteContent, other = __rest(_a, ["name", "className", "value", "size", "placeholder", "ariaLabel", "onChange", "onClick", "onBlur", "onDeleteContent"]);
    var classNameList = classnames(' dl-searchbox', (_b = {},
        _b["dl-searchbox-" + size] = size,
        _b), className);
    return (React.createElement("div", __assign({ className: classNameList }, other),
        React.createElement("div", { className: "dl-searchbox-icon-left" },
            React.createElement(Icon, { name: "magnifying-glass", size: size, role: "img", title: "Search" })),
        React.createElement("input", { className: "dl-form-control", type: "search", name: name, value: value, "aria-label": ariaLabel, placeholder: placeholder, ref: ref, onChange: onChange, onClick: onClick, onBlur: onBlur }),
        React.createElement("div", { className: "dl-searchbox-icon-right" }, !!value && (React.createElement(Icon, { name: "x", size: "sm", role: "button", onClick: function (e) {
                onDeleteContent && onDeleteContent(e);
            } })))));
});
SearchBox.displayName = 'SearchBox';

var SectionMessage = React.forwardRef(function (_a, ref) {
    var _b;
    var variant = _a.variant, textOnly = _a.textOnly, className = _a.className, children = _a.children, other = __rest(_a, ["variant", "textOnly", "className", "children"]);
    var classNameList = classnames('dl-section-message', (_b = {},
        _b["dl-message-" + variant] = variant,
        _b), className);
    var icon;
    if (variant === 'positive') {
        icon = '👍';
    }
    if (variant === 'warning') {
        icon = '☝️';
    }
    if (variant === 'negative') {
        icon = '🚫';
    }
    return (React.createElement("div", __assign({ className: classNameList, ref: ref }, other),
        !textOnly && React.createElement("div", { className: "dl-section-message-icon" }, icon),
        React.createElement("div", { className: "dl-section-message-text" }, children)));
});
SectionMessage.defaultProps = {
    variant: 'positive',
    textOnly: false,
};
SectionMessage.displayName = 'SectionMessage';

var SidebarContext = createContext({});
var SidebarContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var openSidebar = function () { return setIsOpen(true); };
    var closeSidebar = function () { return setIsOpen(false); };
    var toggleSidebar = function () { return setIsOpen(!isOpen); };
    return (React.createElement(SidebarContext.Provider, { value: { isOpen: isOpen, setIsOpen: setIsOpen, openSidebar: openSidebar, closeSidebar: closeSidebar, toggleSidebar: toggleSidebar } }, children));
};
var useSidebar = function () { return useContext(SidebarContext); };

var SidebarHeader = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var closeSidebar = useSidebar().closeSidebar;
    var classNameList = classnames('dl-sidebar-header', className);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", __assign({ className: classNameList }, other),
            React.createElement("div", { className: "dl-sidebar-header-content" }, children),
            React.createElement(Button, { variant: "tertiary", title: "Cerrar", isIconOnly: true, iconName: "x", size: "md", onClick: closeSidebar, className: "dl-sidebar-close-button" }))));
};

var SidebarBody = function (_a) {
    var className = _a.className, children = _a.children, other = __rest(_a, ["className", "children"]);
    var isOpen = useSidebar().isOpen;
    var refSidebarContent = useRef(null);
    var classNameList = classnames('dl-sidebar-body', className);
    useEffect(function () {
        return function () {
            setTimeout(function () {
                var _a;
                if (isOpen && (refSidebarContent === null || refSidebarContent === void 0 ? void 0 : refSidebarContent.current)) {
                    (_a = refSidebarContent === null || refSidebarContent === void 0 ? void 0 : refSidebarContent.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                }
            }, 500);
        };
    }, [isOpen]);
    return (React.createElement("div", __assign({ ref: refSidebarContent, className: classNameList }, other), children));
};

var Sidebar = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.isStaticBackdrop, isStaticBackdrop = _c === void 0 ? false : _c, _d = _a.noStickyHeader, noStickyHeader = _d === void 0 ? false : _d, onClickOutside = _a.onClickOutside, className = _a.className, children = _a.children, other = __rest(_a, ["isOpen", "isStaticBackdrop", "noStickyHeader", "onClickOutside", "className", "children"]);
    var closeSidebar = useSidebar().closeSidebar;
    var classNameList = classnames('dl-sidebar dl-sidebar-fixed-left', {
        'dl-sidebar-open': isOpen,
        'dl-sidebar-header-fixed': !noStickyHeader,
    }, className);
    useEffect(function () {
        var _a, _b;
        if (typeof document !== 'undefined') {
            isOpen
                ? (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.classList.add('dl-sidebar-hidden-scroll-y') : (_b = document === null || document === void 0 ? void 0 : document.body) === null || _b === void 0 ? void 0 : _b.classList.remove('dl-sidebar-hidden-scroll-y');
        }
    }, [isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({ className: classNameList }, other), children),
        React.createElement(Backdrop, { isOpen: isOpen, onClick: function () {
                if (onClickOutside) {
                    onClickOutside();
                }
                else {
                    !isStaticBackdrop && closeSidebar();
                }
            } })));
};
Sidebar.Header = SidebarHeader;
Sidebar.Body = SidebarBody;

var Snackbar = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'positive' : _c, _d = _a.isOpen, isOpen = _d === void 0 ? false : _d, _e = _a.isLongMessage, isLongMessage = _e === void 0 ? false : _e, _f = _a.autoHideDuration, autoHideDuration = _f === void 0 ? 4500 : _f, _g = _a.action, action = _g === void 0 ? 'Cerrar' : _g, animationIn = _a.animationIn, animationOut = _a.animationOut, className = _a.className, onClose = _a.onClose, children = _a.children, other = __rest(_a, ["variant", "isOpen", "isLongMessage", "autoHideDuration", "action", "animationIn", "animationOut", "className", "onClose", "children"]);
    var classNameList = classnames('dl-snackbar', (_b = {},
        _b["dl-snackbar-" + variant] = variant,
        _b['dl-snackbar-long-text'] = isLongMessage,
        _b), className);
    var _h = useState(false), showSnackbar = _h[0], setShowSnackbar = _h[1];
    var _j = useState(100), progress = _j[0], setProgress = _j[1];
    var timerToHide = React.useRef();
    var barProgressToHide = React.useRef();
    var finishBarProgress = function () {
        clearInterval(barProgressToHide.current);
    };
    var downloadTimer = function () {
        var timeLeft = autoHideDuration;
        finishBarProgress();
        barProgressToHide.current = window.setInterval(function () {
            if (timeLeft <= -1) {
                finishBarProgress();
            }
            else {
                setProgress(timeLeft / autoHideDuration);
            }
            timeLeft -= 1000;
        }, 10);
    };
    var handleClose = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        onClose && onClose.apply(void 0, args);
    };
    var setTimerToHide = function (duration) {
        if (!onClose || duration == null) {
            return;
        }
        downloadTimer();
        clearTimeout(timerToHide.current);
        timerToHide.current = window.setTimeout(function () {
            handleClose('timeout');
        }, duration);
    };
    //Barra de progreso por defecto, no interaciones del usuario
    useEffect(function () {
        if (isOpen) {
            setShowSnackbar(true);
            setProgress(100);
            setTimerToHide(autoHideDuration);
        }
        return function () {
            clearTimeout(timerToHide.current);
        };
    }, [isOpen]);
    var onAnimationEnd = function () {
        if (!isOpen) {
            setShowSnackbar(false);
            setProgress(100);
            clearTimeout(timerToHide.current);
            clearInterval(barProgressToHide.current);
        }
    };
    return (React.createElement(React.Fragment, null, showSnackbar ? (React.createElement("div", __assign({ className: classNameList, ref: ref, style: {
            animation: (isOpen
                ? animationIn
                    ? animationIn
                    : 'snackbarFadein'
                : animationOut
                    ? animationOut
                    : 'snackbarFadeout') + " 250ms linear",
        }, onAnimationEnd: onAnimationEnd }, other),
        React.createElement("div", { className: "dl-snackbar-progress-bar" },
            React.createElement("div", { className: "dl-progress-counter", style: {
                    width: progress + "%",
                    transition: "width " + autoHideDuration + "ms linear",
                } })),
        React.createElement("div", { className: "dl-snackbar-content-info" },
            React.createElement("div", { className: "dl-snackbar-text" }, children),
            React.createElement(Button, { variant: "tertiary", size: "xs", onClick: handleClose }, action)))) : null));
});
Snackbar.displayName = 'Snackbar';

var SubHeading = function (_a) {
    var _b;
    var children = _a.children, as = _a.as, size = _a.size, className = _a.className, other = __rest(_a, ["children", "as", "size", "className"]);
    var classNameList = classnames((_b = {},
        _b["dl-subheading-" + size] = size,
        _b), className);
    var commonProps = {
        className: classNameList,
    };
    var component = 'h2';
    as && (component = as);
    return React.createElement(component, __assign(__assign({}, commonProps), other), children);
};
SubHeading.defaultProps = {
    as: 'h2',
    size: 'lg',
};

var Tag = function (_a) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? 'success' : _c, children = _a.children, className = _a.className, other = __rest(_a, ["type", "children", "className"]);
    var classNameList = classnames('dl-tag', (_b = {},
        _b["dl-tag-" + type] = type,
        _b), className);
    return (React.createElement("label", __assign({ className: classNameList }, other), children));
};

var getDeviceType = function () {
    var device = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(device)) {
        return 'tablet';
    }
    if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(device)) {
        return 'mobile';
    }
    return 'desktop';
};

var sizes = {
    desktop: tokens.dlGridBreakpointDesktop,
    mobile: tokens.dlGridBreakpointMobile,
};
var Responsive = {
    sizes: sizes,
    queries: {
        minDesktop: "(min-width: " + sizes.desktop + ")",
        maxMobile: "(max-width: " + sizes.mobile + ")",
        minMobile: "(min-width: " + sizes.mobile + ")",
        maxDesktop: "(max-width: " + sizes.desktop + ")",
    },
};

var isExistWindow = typeof window !== 'undefined';
var windowWidth = isExistWindow ? window === null || window === void 0 ? void 0 : window.innerWidth : 0;
var windowHeight = isExistWindow ? window === null || window === void 0 ? void 0 : window.innerHeight : 0;
var defaultValues = {
    dimensions: {
        width: windowWidth,
        height: windowHeight,
    },
    current: {
        isMobile: false,
        isDesktop: false,
        isTablet: false,
    },
};
var useWindowSize = function () {
    var _a = useState(defaultValues), device = _a[0], setDevice = _a[1];
    var deviceType = getDeviceType();
    var handleResizeWindow = function () {
        var isDesktop = windowWidth >= Number(Responsive.sizes.desktop);
        var isMobile = windowWidth <= Number(Responsive.sizes.mobile);
        var isTablet = !isDesktop && !isMobile;
        setDevice(__assign(__assign({}, device), { current: {
                device: deviceType,
                isMobile: isMobile,
                isDesktop: isDesktop,
                isTablet: isTablet,
            }, dimensions: {
                width: windowWidth,
                height: windowHeight,
            } }));
    };
    useEffect(function () {
        if (isExistWindow) {
            window === null || window === void 0 ? void 0 : window.addEventListener('resize', handleResizeWindow);
        }
        return function () {
            if (isExistWindow) {
                window === null || window === void 0 ? void 0 : window.removeEventListener('resize', handleResizeWindow);
            }
        };
    }, []);
    useLayoutEffect(function () {
        handleResizeWindow();
    }, []);
    return device;
};

export { AlertBanner, AlertBannerButtons, AlertBannerMessage, AlertBannerSeparator, Avatar, Backdrop, Brand, Button, CardProduct, CardProductActions, CardProductAmounts, CardProductBody, CardProductBodyBottom, CardProductBodyTop, CardProductDescription, CardProductDiscountPrice, CardProductFinalPrice, CardProductHeader, CardProductImage, CardProductTitle, Check, Divider, Dropdown, Form, FormGroup, Heading, HelperText, Icon, Img, Input, InputAmount, InputAmountDecrease, InputAmountIncrease, InputAmountInput, Isotype, Label, Link, Logotype, Navbar, SearchBox, SectionMessage, Select, SelectItem, Sidebar, SidebarBody, SidebarContextProvider, SidebarHeader, Snackbar, SubHeading, Tag, Text, Textarea, useSidebar, useWindowSize };
//# sourceMappingURL=index.es.js.map
